/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type AiStartChatRequestInput = {
  giideId: string;
  input: string;
  script?: string | null;
};

export type AiStartChatRequestOutput = {
  __typename: 'AiStartChatRequestOutput';
  id?: string | null;
  success: boolean;
  error?: string | null;
};

export type AiGetChatResponseInput = {
  userId: string;
  tenantId: string;
  giideId: string;
  script?: string | null;
};

export type AiGetChatResponseOutput = {
  __typename: 'AiGetChatResponseOutput';
  giideId: string;
  script: string;
};

export type GiidePasswordInput = {
  giideId: string;
  action?: GiidePasswordAction | null;
  password: string;
};

export enum GiidePasswordAction {
  create = 'create',
  remove = 'remove',
  check = 'check',
}

export type GiidePasswordOutput = {
  __typename: 'GiidePasswordOutput';
  success: boolean;
  error?: string | null;
};

export type UnsplashTrackDownloadInput = {
  downloadLocation: string;
};

export type UnsplashTrackDownloadOutput = {
  __typename: 'UnsplashTrackDownloadOutput';
  type: string;
};

export type PaddleUpdateUserPlanInput = {
  planIDToSwitchTo?: number | null;
};

export type PaddleUpdateUserPlanOutput = {
  __typename: 'PaddleUpdateUserPlanOutput';
  planID: string;
  subscriptionID: string;
  error?: string | null;
};

export type CreateNewGiideOutput = {
  __typename: 'CreateNewGiideOutput';
  giideID?: string | null;
  userID?: string | null;
  tenantID?: string | null;
  stepID?: string | null;
};

export type PublishGiideInput = {
  userId: string;
  giideId: string;
  isPreview?: boolean | null;
  isReview?: boolean | null;
  categoryIndex?: number | null;
};

export type PublishGiideOutput = {
  __typename: 'PublishGiideOutput';
  result?: string | null;
  error?: string | null;
  code?: string | null;
};

export type ExportVideoUpdateInput = {
  id: string;
  status?: string | null;
  progress?: number | null;
  error?: boolean | null;
};

export type ExportVideoOutput = {
  __typename: 'ExportVideoOutput';
  id: string;
  error?: boolean | null;
  status?: string | null;
  progress?: number | null;
};

export type UpdateTranscriptContentInput = {
  giideId: string;
  transcriptItemID: string;
  recordingID: string;
  content: string;
};

export type GetTranscriptOutput = {
  __typename: 'GetTranscriptOutput';
  transcript?: string | null;
};

export type inputUpdateGiideEmbedSettings = {
  id: string;
  embedCodeState: string;
  embedCodeAllowedDomains: Array<string | null>;
};

export type UpdateGiideEmbedSettingsResponses = {
  __typename: 'UpdateGiideEmbedSettingsResponses';
  id: string;
  owner: string;
  tenantID: string;
  embedCodeState: string;
  embedCodeAllowedDomains: Array<string | null>;
};

export type inputCopyGiide = {
  id: string;
};

export type CopyGiideResponses = {
  __typename: 'CopyGiideResponses';
  newGiideId: string;
  owner: string;
  tenantID: string;
};

export type StepReorderInput = {
  stepId: string;
  newStepOrder: number;
  giideId: string;
};

export type StepReorderOutput = {
  __typename: 'StepReorderOutput';
  id?: string | null;
  success?: boolean | null;
  error?: string | null;
};

export type MobileAppEmailOutput = {
  __typename: 'MobileAppEmailOutput';
  success: boolean;
};

export type UnlinkRecordingInput = {
  id: string;
  timestamp?: string | null;
};

export type UnlinkRecordingOutput = {
  __typename: 'UnlinkRecordingOutput';
  success: boolean;
};

export type RelinkFeedCardInput = {
  id: string;
  recordingId: string;
  time: number;
};

export type RelinkFeedCardOutput = {
  __typename: 'RelinkFeedCardOutput';
  success: boolean;
};

export type UnpublishGiideInput = {
  giideId: string;
};

export type UnpublishGiideOutput = {
  __typename: 'UnpublishGiideOutput';
  success: boolean;
  error?: string | null;
};

export type DeleteGiideAllInput = {
  giideId: string;
};

export type DeleteGiideAllOutput = {
  __typename: 'DeleteGiideAllOutput';
  success: boolean;
  error?: string | null;
};

export type UpdateUserProfileInput = {
  title?: string | null;
  fullName?: string | null;
  profileImageName?: string | null;
  profileImageId?: string | null;
  profileImageService?: string | null;
  preferences?: UserProfilePreferencesInput | null;
};

export type UserProfilePreferencesInput = {
  firstLoginVideo?: boolean | null;
  dontShowPublishInfoTooltip?: boolean | null;
  dontShowFeedcardWordTooltip?: boolean | null;
  dontShowGetStartedModal?: boolean | null;
  dontShowTranscriptAnnouncementBanner?: boolean | null;
};

export type UserProfileOutput = {
  __typename: 'UserProfileOutput';
  role: string;
  userID: string;
  email?: string | null;
  fullName?: string | null;
  title?: string | null;
  profileImageName?: string | null;
  profileImageService?: string | null;
  profileImageId?: string | null;
  preferences?: GetUserProfilePreferencesOutput | null;
  giidesCreatedListFreePlan?: Array<GetUserProfileGiidesCreatedListFreePlanOutput | null> | null;
};

export type GetUserProfilePreferencesOutput = {
  __typename: 'GetUserProfilePreferencesOutput';
  firstLoginVideo?: boolean | null;
  dontShowPublishInfoTooltip?: boolean | null;
  dontShowFeedcardWordTooltip?: boolean | null;
  dontShowGetStartedModal?: boolean | null;
  dontShowTranscriptAnnouncementBanner?: boolean | null;
};

export type GetUserProfileGiidesCreatedListFreePlanOutput = {
  __typename: 'GetUserProfileGiidesCreatedListFreePlanOutput';
  createdAt: string;
  giideID: string;
  updatedAt: string;
};

export type MoveFeedCardInput = {
  feedCardId: string;
  time: number;
};

export type MoveFeedCardOutput = {
  __typename: 'MoveFeedCardOutput';
  success: boolean;
  error?: string | null;
};

export type SelectRecordingFromLibraryInput = {
  libraryRecordId: string;
  recordingStepId?: string | null;
  stepId: string;
  giideId: string;
  duration?: number | null;
};

export type SelectRecordingFromLibraryOutput = {
  __typename: 'SelectRecordingFromLibraryOutput';
  success: boolean;
  error?: string | null;
  filePath?: string | null;
};

export type CopySampleAudioInput = {
  stepId: string;
  giideId: string;
};

export type CopySampleAudioOutput = {
  __typename: 'CopySampleAudioOutput';
  success: boolean;
  error?: string | null;
  filePath?: string | null;
};

export type InviteUserInput = {
  items: Array<EmailInvite>;
};

export type EmailInvite = {
  email: string;
  giideId: string;
  isNew: boolean;
  isDeleted: boolean;
};

export type InviteUserOutput = {
  __typename: 'InviteUserOutput';
  success: boolean;
  error?: string | null;
};

export type DeleteAllInvitesInput = {
  giideId: string;
};

export type DeleteAllInvitesOutput = {
  __typename: 'DeleteAllInvitesOutput';
  success: boolean;
  error?: string | null;
};

export type UpdateUserPlanTimeStampInput = {
  userID: string;
  tenantID: string;
};

export type GetPlanOutput = {
  __typename: 'GetPlanOutput';
  id?: string | null;
  versionID?: string | null;
  updatedAt?: string | null;
  createdAt?: string | null;
  price?: number | null;
  name?: string | null;
  features?: PlanFeatures | null;
  userID?: string | null;
  tenantID?: string | null;
  giidesCreatedListFreePlan?: Array<GiidesCreated | null> | null;
  giidesCreatedListProPlan?: Array<GiidesCreated | null> | null;
  subscriptionIDs?: Array<number | null> | null;
  accountStatus?: string | null;
  freeTrialEndDate?: string | null;
  totalGiidesCreated?: number | null;
  upgradePlans?: Array<number | null> | null;
  downgradePlans?: Array<number | null> | null;
  planChangeError?: string | null;
  paddlePlanID?: number | null;
};

export type PlanFeatures = {
  __typename: 'PlanFeatures';
  giideMaxLengthAudio?: PlanMaxLengthAudio | null;
  giideMaxFileSizeAudio?: PlanMaxFileSizeAudio | null;
  giideMaxNumberOfGiides?: PlanMaxNumberOfGiides | null;
  chapters?: PlanChapters | null;
  recording?: PlanRecording | null;
  embedCode?: PlanEmbedCode | null;
  pollQuizFeature?: PlanPollQuizFeature | null;
  giidePasswordProtection?: PlanGiidePasswordProtection | null;
  giideDuplicate?: PlanGiideDuplicate | null;
};

export type PlanMaxLengthAudio = {
  __typename: 'PlanMaxLengthAudio';
  name?: string | null;
  createdAt?: string | null;
  isActive?: boolean | null;
  giideLengthInSeconds?: number | null;
  updatedAt?: string | null;
};

export type PlanMaxFileSizeAudio = {
  __typename: 'PlanMaxFileSizeAudio';
  name?: string | null;
  createdAt?: string | null;
  isActive?: boolean | null;
  giideMaxFileSizeMBAudio?: number | null;
  updatedAt?: string | null;
};

export type PlanMaxNumberOfGiides = {
  __typename: 'PlanMaxNumberOfGiides';
  createdAt?: string | null;
  hasLimit?: boolean | null;
  isActive?: boolean | null;
  limitAmount?: number | null;
  name?: string | null;
  updatedAt?: string | null;
};

export type PlanChapters = {
  __typename: 'PlanChapters';
  name?: string | null;
  createdAt?: string | null;
  isActive?: boolean | null;
  hasLimit?: boolean | null;
  maxNumberOfChapters?: number | null;
  allowChaptersWithFutureGiides?: boolean | null;
  allowChaptersWithExistingGiides?: boolean | null;
  updatedAt?: string | null;
};

export type PlanRecording = {
  __typename: 'PlanRecording';
  name?: string | null;
  createdAt?: string | null;
  hasBrowserRecording?: boolean | null;
  updatedAt?: string | null;
};

export type PlanEmbedCode = {
  __typename: 'PlanEmbedCode';
  name?: string | null;
  createdAt?: string | null;
  isActive?: boolean | null;
  updatedAt?: string | null;
  allowEmbedCode?: boolean | null;
};

export type PlanPollQuizFeature = {
  __typename: 'PlanPollQuizFeature';
  name?: string | null;
  createdAt?: string | null;
  isActive?: boolean | null;
  updatedAt?: string | null;
  allowFeature?: boolean | null;
};

export type PlanGiidePasswordProtection = {
  __typename: 'PlanGiidePasswordProtection';
  allowGiidePasswordProtection?: boolean | null;
  createdAt?: string | null;
  isActive?: boolean | null;
  name?: string | null;
  updatedAt?: string | null;
};

export type PlanGiideDuplicate = {
  __typename: 'PlanGiideDuplicate';
  allowGiideDuplicate?: boolean | null;
  createdAt?: string | null;
  isActive?: boolean | null;
  name?: string | null;
  updatedAt?: string | null;
};

export type GiidesCreated = {
  __typename: 'GiidesCreated';
  giideID?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type CreateGiideInput = {
  id?: string | null;
  title: string;
  description?: string | null;
  tenantID?: string | null;
  speaker?: SpeakerInput | null;
  publishState?: PublishState | null;
  unauthenticatedAccessAllowed?: boolean | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  publishedAt?: string | null;
  previewedAt?: string | null;
  cardDetails?: CardDetailsInput | null;
  preview?: boolean | null;
  isInGiideStudioLibrary?: boolean | null;
  giideLibraryId?: string | null;
  useOwnDescription?: boolean | null;
  useOwnAuthorBio?: boolean | null;
  useGiideTones?: boolean | null;
  script?: string | null;
  hasChapters?: boolean | null;
  noindex?: boolean | null;
  embedCodeState?: string | null;
  embedCodeAllowedDomains?: Array<string | null> | null;
};

export type SpeakerInput = {
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  bio?: string | null;
  title?: string | null;
  socialUrls?: SocialUrlsInput | null;
  profile?: string | null;
  headshotPath?: string | null;
};

export type SocialUrlsInput = {
  facebook?: string | null;
  twitter?: string | null;
  linkedin?: string | null;
  website?: string | null;
};

export enum PublishState {
  unpublished = 'unpublished',
  review = 'review',
  migrating = 'migrating',
  transcoding = 'transcoding',
  published = 'published',
  error = 'error',
}

export type CardDetailsInput = {
  cardColor?: string | null;
  cardShade?: string | null;
  thumbnailImg?: string | null;
  thumbnailCustomName?: string | null;
  thumbnailCustomPath?: string | null;
  thumbnailImageService?: ImageService | null;
  useCustomThumbnail?: boolean | null;
  colorLeft?: string | null;
  colorRight?: string | null;
  thumbnailLarge?: string | null;
  thumbnailSmall?: string | null;
};

export enum ImageService {
  cloudinary = 'cloudinary',
}

export type ModelGiideConditionInput = {
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  tenantID?: ModelStringInput | null;
  publishState?: ModelPublishStateInput | null;
  unauthenticatedAccessAllowed?: ModelBooleanInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  publishedAt?: ModelStringInput | null;
  previewedAt?: ModelStringInput | null;
  preview?: ModelBooleanInput | null;
  isInGiideStudioLibrary?: ModelBooleanInput | null;
  giideLibraryId?: ModelStringInput | null;
  useOwnDescription?: ModelBooleanInput | null;
  useOwnAuthorBio?: ModelBooleanInput | null;
  useGiideTones?: ModelBooleanInput | null;
  script?: ModelStringInput | null;
  hasChapters?: ModelBooleanInput | null;
  noindex?: ModelBooleanInput | null;
  embedCodeState?: ModelStringInput | null;
  embedCodeAllowedDomains?: ModelStringInput | null;
  and?: Array<ModelGiideConditionInput | null> | null;
  or?: Array<ModelGiideConditionInput | null> | null;
  not?: ModelGiideConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = 'binary',
  binarySet = 'binarySet',
  bool = 'bool',
  list = 'list',
  map = 'map',
  number = 'number',
  numberSet = 'numberSet',
  string = 'string',
  stringSet = 'stringSet',
  _null = '_null',
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelPublishStateInput = {
  eq?: PublishState | null;
  ne?: PublishState | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type Giide = {
  __typename: 'Giide';
  id: string;
  title: string;
  description?: string | null;
  steps?: ModelStepConnection | null;
  tenantID?: string | null;
  speaker?: Speaker | null;
  publishState?: PublishState | null;
  exportVideoState?: string | null;
  unauthenticatedAccessAllowed?: boolean | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  publishedAt?: string | null;
  publishedWithTranscript?: boolean | null;
  previewedAt?: string | null;
  cardDetails?: CardDetails | null;
  preview?: boolean | null;
  isInGiideStudioLibrary?: boolean | null;
  giideLibraryId?: string | null;
  useOwnDescription?: boolean | null;
  useOwnAuthorBio?: boolean | null;
  useGiideTones?: boolean | null;
  script?: string | null;
  hasChapters?: boolean | null;
  noindex?: boolean | null;
  embedCodeState?: string | null;
  embedCodeAllowedDomains?: Array<string | null> | null;
  passwordEnabled?: boolean | null;
};

export type ModelStepConnection = {
  __typename: 'ModelStepConnection';
  items: Array<Step | null>;
  nextToken?: string | null;
};

export type Step = {
  __typename: 'Step';
  id: string;
  title: string;
  order: number;
  script?: string | null;
  giide: Giide;
  tenantID?: string | null;
  open?: boolean | null;
  ownRecordingUploaded?: boolean | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  recording?: Recording | null;
};

export type Recording = {
  __typename: 'Recording';
  id: string;
  deleted?: boolean | null;
  length: number;
  step: Step;
  feedCards?: ModelFeedCardConnection | null;
  transcriptResults?: TranscriptResults | null;
  tenantID?: string | null;
  filePath?: string | null;
  transcriptPath?: string | null;
  transcriptError?: string | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  giideId?: string | null;
  libraryRecordId?: string | null;
};

export type ModelFeedCardConnection = {
  __typename: 'ModelFeedCardConnection';
  items: Array<FeedCard | null>;
  nextToken?: string | null;
};

export type FeedCard = {
  __typename: 'FeedCard';
  nonLibraryGiideID?: string | null;
  id: string;
  source?: string | null;
  time: number;
  title?: string | null;
  type: CardType;
  url?: string | null;
  context?: string | null;
  affiliation?: string | null;
  text?: string | null;
  caption?: string | null;
  question?: string | null;
  feedCardIdForAnalytics?: string | null;
  questionHasCorrectAnswer?: boolean | null;
  customHeader?: string | null;
  questionType?: QuestionType | null;
  answerDetails?: AnswerDetails | null;
  resourceType?: ResourceType | null;
  iconUrl?: string | null;
  imageUrl?: string | null;
  socialUrls?: SocialUrls | null;
  bold?: string | null;
  term?: string | null;
  tenantID?: string | null;
  numbered?: boolean | null;
  listItems?: Array<string | null> | null;
  author?: string | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  expertise?: string | null;
  unlinked?: boolean | null;
  customImage?: string | null;
  customImageName?: string | null;
  giideId?: string | null;
  feedCardRecordingId?: string | null;
  imageDetails?: FeedCardImageDetails | null;
  htmlText?: string | null;
  imageService?: ImageService | null;
  recording: Recording;
};

export enum CardType {
  profile = 'profile',
  highlight = 'highlight',
  resource = 'resource',
  graphic = 'graphic',
  definition = 'definition',
  activity = 'activity',
  quote = 'quote',
  list = 'list',
  quiz = 'quiz',
  factoid = 'factoid',
  portrait = 'portrait',
  welcome = 'welcome',
  poll = 'poll',
  video = 'video',
  text = 'text',
}

export enum QuestionType {
  openEndedTextResponse = 'openEndedTextResponse',
  multipleChoiceSingleResponse = 'multipleChoiceSingleResponse',
}

export type AnswerDetails = {
  __typename: 'AnswerDetails';
  answerOptions?: Array<AnswerOption> | null;
  userAnswer?: string | null;
  userAnswerIsCorrect?: boolean | null;
  correctAnswerIndex?: number | null;
};

export type AnswerOption = {
  __typename: 'AnswerOption';
  index: number;
  sortOrder: number;
  text: string;
};

export enum ResourceType {
  website = 'website',
  survey = 'survey',
  book = 'book',
  article = 'article',
  audio = 'audio',
  video = 'video',
}

export type SocialUrls = {
  __typename: 'SocialUrls';
  facebook?: string | null;
  twitter?: string | null;
  linkedin?: string | null;
  website?: string | null;
};

export type FeedCardImageDetails = {
  __typename: 'FeedCardImageDetails';
  url?: string | null;
  description?: string | null;
  altDescription?: string | null;
  attributionUserName?: string | null;
  width?: number | null;
  height?: number | null;
  attributionFirstName?: string | null;
  attributionLastName?: string | null;
  attributionFullName?: string | null;
  caption?: string | null;
  imageTypeSelected?: FeedCardImageType | null;
  userUploadedImageDetails?: FeedCardUserUploadedImageDetails | null;
};

export enum FeedCardImageType {
  userUploadedImage = 'userUploadedImage',
  unsplashImage = 'unsplashImage',
  giphyImage = 'giphyImage',
}

export type FeedCardUserUploadedImageDetails = {
  __typename: 'FeedCardUserUploadedImageDetails';
  customImageName?: string | null;
};

export type TranscriptResults = {
  __typename: 'TranscriptResults';
  items: Array<TranscriptItem>;
  transcript?: string | null;
};

export type TranscriptItem = {
  __typename: 'TranscriptItem';
  alternatives: Array<TranscriptAlternatives>;
  start_time?: string | null;
  end_time?: string | null;
  type: TranscriptItemType;
};

export type TranscriptAlternatives = {
  __typename: 'TranscriptAlternatives';
  confidence: string;
  content: string;
};

export enum TranscriptItemType {
  pronunciation = 'pronunciation',
  punctuation = 'punctuation',
}

export type Speaker = {
  __typename: 'Speaker';
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  bio?: string | null;
  title?: string | null;
  socialUrls?: SocialUrls | null;
  profile?: string | null;
  headshotPath?: string | null;
};

export type CardDetails = {
  __typename: 'CardDetails';
  cardColor?: string | null;
  cardShade?: string | null;
  thumbnailImg?: string | null;
  thumbnailCustomName?: string | null;
  thumbnailCustomPath?: string | null;
  thumbnailImageService?: ImageService | null;
  useCustomThumbnail?: boolean | null;
  colorLeft?: string | null;
  colorRight?: string | null;
  thumbnailLarge?: string | null;
  thumbnailSmall?: string | null;
};

export type UpdateGiideInput = {
  id: string;
  title?: string | null;
  description?: string | null;
  tenantID?: string | null;
  speaker?: SpeakerInput | null;
  publishState?: PublishState | null;
  unauthenticatedAccessAllowed?: boolean | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  publishedAt?: string | null;
  previewedAt?: string | null;
  cardDetails?: CardDetailsInput | null;
  preview?: boolean | null;
  isInGiideStudioLibrary?: boolean | null;
  giideLibraryId?: string | null;
  useOwnDescription?: boolean | null;
  useOwnAuthorBio?: boolean | null;
  useGiideTones?: boolean | null;
  script?: string | null;
  hasChapters?: boolean | null;
  noindex?: boolean | null;
  embedCodeState?: string | null;
  embedCodeAllowedDomains?: Array<string | null> | null;
};

export type DeleteGiideInput = {
  id: string;
};

export type CreateStepInput = {
  id?: string | null;
  title: string;
  order: number;
  script?: string | null;
  tenantID?: string | null;
  open?: boolean | null;
  ownRecordingUploaded?: boolean | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  stepGiideId: string;
  stepRecordingId?: string | null;
};

export type ModelStepConditionInput = {
  title?: ModelStringInput | null;
  order?: ModelIntInput | null;
  script?: ModelStringInput | null;
  tenantID?: ModelStringInput | null;
  open?: ModelBooleanInput | null;
  ownRecordingUploaded?: ModelBooleanInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelStepConditionInput | null> | null;
  or?: Array<ModelStepConditionInput | null> | null;
  not?: ModelStepConditionInput | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type UpdateStepInput = {
  id: string;
  title?: string | null;
  order?: number | null;
  script?: string | null;
  tenantID?: string | null;
  open?: boolean | null;
  ownRecordingUploaded?: boolean | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  stepGiideId?: string | null;
  stepRecordingId?: string | null;
};

export type DeleteStepInput = {
  id: string;
};

export type CreateRecordingInput = {
  id?: string | null;
  deleted?: boolean | null;
  length: number;
  transcriptResults?: TranscriptResultsInput | null;
  tenantID?: string | null;
  filePath?: string | null;
  transcriptPath?: string | null;
  transcriptError?: string | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  giideId?: string | null;
  libraryRecordId?: string | null;
  recordingStepId: string;
};

export type TranscriptResultsInput = {
  items: Array<TranscriptItemInput>;
  transcript?: string | null;
};

export type TranscriptItemInput = {
  alternatives: Array<TranscriptAlternativesInput>;
  start_time?: string | null;
  end_time?: string | null;
  transcriptItemID?: string | null;
  type: TranscriptItemType;
};

export type TranscriptAlternativesInput = {
  confidence: string;
  content: string;
};

export type ModelRecordingConditionInput = {
  deleted?: ModelBooleanInput | null;
  length?: ModelIntInput | null;
  tenantID?: ModelStringInput | null;
  filePath?: ModelStringInput | null;
  transcriptPath?: ModelStringInput | null;
  transcriptError?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  giideId?: ModelIDInput | null;
  libraryRecordId?: ModelIDInput | null;
  and?: Array<ModelRecordingConditionInput | null> | null;
  or?: Array<ModelRecordingConditionInput | null> | null;
  not?: ModelRecordingConditionInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type DeleteRecordingInput = {
  id: string;
};

export type CreateUserAudioLibraryInput = {
  id?: string | null;
  audioUrl?: string | null;
  createdAt?: string | null;
  durationSeconds?: number | null;
  tenantID?: string | null;
  title?: string | null;
  updatedAt?: string | null;
  userID: string;
  state?: string | null;
  errorMessage?: string | null;
  errorMessageDisplayToUser?: string | null;
  originalFileExtension?: string | null;
  originalFileMimeType?: string | null;
  uploadSource?: string | null;
};

export type ModelUserAudioLibraryConditionInput = {
  audioUrl?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  durationSeconds?: ModelIntInput | null;
  tenantID?: ModelStringInput | null;
  title?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  userID?: ModelStringInput | null;
  state?: ModelStringInput | null;
  errorMessage?: ModelStringInput | null;
  errorMessageDisplayToUser?: ModelStringInput | null;
  originalFileExtension?: ModelStringInput | null;
  originalFileMimeType?: ModelStringInput | null;
  uploadSource?: ModelStringInput | null;
  and?: Array<ModelUserAudioLibraryConditionInput | null> | null;
  or?: Array<ModelUserAudioLibraryConditionInput | null> | null;
  not?: ModelUserAudioLibraryConditionInput | null;
};

export type UserAudioLibrary = {
  __typename: 'UserAudioLibrary';
  id: string;
  audioUrl?: string | null;
  createdAt?: string | null;
  durationSeconds?: number | null;
  tenantID?: string | null;
  title?: string | null;
  updatedAt?: string | null;
  userID: string;
  state?: string | null;
  errorMessage?: string | null;
  errorMessageDisplayToUser?: string | null;
  originalFileExtension?: string | null;
  originalFileMimeType?: string | null;
  uploadSource?: string | null;
};

export type DeleteUserAudioLibraryInput = {
  id: string;
};

export type CreateOrUpdateUserImageRecordInput = {
  userID: string;
  id: string;
  type?: ImageUploadType | null;
  giideId?: string | null;
  feedCardId?: string | null;
  imageUrl?: string | null;
  imageService?: ImageService | null;
  createdAt?: string | null;
  fileName?: string | null;
  state?: string | null;
  originalFileExtension?: string | null;
  originalFileMimeType?: string | null;
  errorMessage?: string | null;
  errorMessageDisplayToUser?: string | null;
};

export enum ImageUploadType {
  feedCard = 'feedCard',
  thumbnail = 'thumbnail',
  avatar = 'avatar',
}

export type UserImage = {
  __typename: 'UserImage';
  id: string;
  userID: string;
  feedCardId?: string | null;
  imageUrl?: string | null;
  type?: ImageUploadType | null;
  imageService?: ImageService | null;
  createdAt?: string | null;
  fileName?: string | null;
  state?: string | null;
  originalFileExtension?: string | null;
  originalFileMimeType?: string | null;
  errorMessage?: string | null;
  errorMessageDisplayToUser?: string | null;
};

export type CreateFeedCardInput = {
  nonLibraryGiideID?: string | null;
  id?: string | null;
  source?: string | null;
  time: number;
  title?: string | null;
  type: CardType;
  url?: string | null;
  context?: string | null;
  affiliation?: string | null;
  text?: string | null;
  caption?: string | null;
  question?: string | null;
  feedCardIdForAnalytics?: string | null;
  questionHasCorrectAnswer?: boolean | null;
  customHeader?: string | null;
  questionType?: QuestionType | null;
  answerDetails?: AnswerDetailsInput | null;
  resourceType?: ResourceType | null;
  iconUrl?: string | null;
  imageUrl?: string | null;
  socialUrls?: SocialUrlsInput | null;
  imageDetails?: FeedCardImageDetailsInput | null;
  bold?: string | null;
  term?: string | null;
  tenantID?: string | null;
  numbered?: boolean | null;
  listItems?: Array<string | null> | null;
  author?: string | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  expertise?: string | null;
  unlinked?: boolean | null;
  customImage?: string | null;
  customImageName?: string | null;
  giideId?: string | null;
  feedCardRecordingId?: string | null;
  htmlText?: string | null;
  imageService?: ImageService | null;
};

export type AnswerDetailsInput = {
  answerOptions?: Array<AnswerOptionInput> | null;
  userAnswer?: string | null;
  userAnswerIsCorrect?: boolean | null;
  correctAnswerIndex?: number | null;
};

export type AnswerOptionInput = {
  index: number;
  sortOrder: number;
  text: string;
};

export type FeedCardImageDetailsInput = {
  url: string;
  description?: string | null;
  altDescription?: string | null;
  attributionUserName?: string | null;
  width?: number | null;
  height?: number | null;
  attributionFirstName?: string | null;
  attributionLastName?: string | null;
  attributionFullName?: string | null;
  caption?: string | null;
  imageTypeSelected: FeedCardImageType;
  userUploadedImageDetails?: FeedCardUserUploadedImageDetailsInput | null;
};

export type FeedCardUserUploadedImageDetailsInput = {
  customImageName?: string | null;
};

export type ModelFeedCardConditionInput = {
  nonLibraryGiideID?: ModelIDInput | null;
  source?: ModelStringInput | null;
  time?: ModelFloatInput | null;
  title?: ModelStringInput | null;
  type?: ModelCardTypeInput | null;
  url?: ModelStringInput | null;
  context?: ModelStringInput | null;
  affiliation?: ModelStringInput | null;
  text?: ModelStringInput | null;
  caption?: ModelStringInput | null;
  question?: ModelStringInput | null;
  feedCardIdForAnalytics?: ModelStringInput | null;
  questionHasCorrectAnswer?: ModelBooleanInput | null;
  customHeader?: ModelStringInput | null;
  questionType?: ModelQuestionTypeInput | null;
  resourceType?: ModelResourceTypeInput | null;
  iconUrl?: ModelStringInput | null;
  imageUrl?: ModelStringInput | null;
  bold?: ModelStringInput | null;
  term?: ModelStringInput | null;
  tenantID?: ModelStringInput | null;
  numbered?: ModelBooleanInput | null;
  listItems?: ModelStringInput | null;
  author?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  firstName?: ModelStringInput | null;
  lastName?: ModelStringInput | null;
  fullName?: ModelStringInput | null;
  expertise?: ModelStringInput | null;
  unlinked?: ModelBooleanInput | null;
  customImage?: ModelStringInput | null;
  customImageName?: ModelStringInput | null;
  giideId?: ModelIDInput | null;
  feedCardRecordingId?: ModelIDInput | null;
  htmlText?: ModelStringInput | null;
  and?: Array<ModelFeedCardConditionInput | null> | null;
  or?: Array<ModelFeedCardConditionInput | null> | null;
  not?: ModelFeedCardConditionInput | null;
};

export type ModelFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelCardTypeInput = {
  eq?: CardType | null;
  ne?: CardType | null;
};

export type ModelQuestionTypeInput = {
  eq?: QuestionType | null;
  ne?: QuestionType | null;
};

export type ModelResourceTypeInput = {
  eq?: ResourceType | null;
  ne?: ResourceType | null;
};

export type UpdateFeedCardInput = {
  nonLibraryGiideID?: string | null;
  id: string;
  source?: string | null;
  time?: number | null;
  title?: string | null;
  type?: CardType | null;
  url?: string | null;
  context?: string | null;
  affiliation?: string | null;
  text?: string | null;
  caption?: string | null;
  question?: string | null;
  feedCardIdForAnalytics?: string | null;
  questionHasCorrectAnswer?: boolean | null;
  customHeader?: string | null;
  questionType?: QuestionType | null;
  answerDetails?: AnswerDetailsInput | null;
  resourceType?: ResourceType | null;
  iconUrl?: string | null;
  imageUrl?: string | null;
  imageService?: ImageService | null;
  socialUrls?: SocialUrlsInput | null;
  imageDetails?: FeedCardImageDetailsInputUpdate | null;
  bold?: string | null;
  term?: string | null;
  tenantID?: string | null;
  numbered?: boolean | null;
  listItems?: Array<string | null> | null;
  author?: string | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  expertise?: string | null;
  unlinked?: boolean | null;
  customImage?: string | null;
  customImageName?: string | null;
  giideId?: string | null;
  feedCardRecordingId?: string | null;
  htmlText?: string | null;
};

export type FeedCardImageDetailsInputUpdate = {
  url?: string | null;
  description?: string | null;
  altDescription?: string | null;
  attributionUserName?: string | null;
  width?: number | null;
  height?: number | null;
  attributionFirstName?: string | null;
  attributionLastName?: string | null;
  attributionFullName?: string | null;
  caption?: string | null;
  imageTypeSelected?: FeedCardImageType | null;
  userUploadedImageDetails?: FeedCardUserUploadedImageDetailsInput | null;
};

export type DeleteFeedCardInput = {
  id: string;
};

export type DeleteFeedCardOutput = {
  __typename: 'DeleteFeedCardOutput';
  success: boolean;
  error?: string | null;
};

export type UpdateRecordingInput = {
  id: string;
  deleted?: boolean | null;
  length?: number | null;
  transcriptResults?: TranscriptResultsInput | null;
  tenantID?: string | null;
  filePath?: string | null;
  transcriptPath?: string | null;
  transcriptError?: string | null;
  owner?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  giideId?: string | null;
  libraryRecordId?: string | null;
  recordingStepId?: string | null;
};

export type UpdateUserAudioLibraryInput = {
  id: string;
  audioUrl?: string | null;
  createdAt?: string | null;
  durationSeconds?: number | null;
  tenantID?: string | null;
  title?: string | null;
  updatedAt?: string | null;
  userID?: string | null;
  state?: string | null;
  errorMessage?: string | null;
  errorMessageDisplayToUser?: string | null;
  originalFileExtension?: string | null;
  originalFileMimeType?: string | null;
  uploadSource?: string | null;
};

export type GetUrlInput = {
  type?: RequestType | null;
  fileKey: string;
  fileName?: string | null;
  giideId?: string | null;
  bucket?: string | null;
  resourceType?: UrlResourceType | null;
  service?: ImageService | null;
};

export enum RequestType {
  get = 'get',
  post = 'post',
}

export enum UrlResourceType {
  asset = 'asset',
  userRecording = 'userRecording',
  headshot = 'headshot',
}

export type GetUrlOutput = {
  __typename: 'GetUrlOutput';
  success: boolean;
  error?: string | null;
  url?: string | null;
  fields?: string | null;
};

export type GetUrlMetaDataOutput = {
  __typename: 'GetUrlMetaDataOutput';
  title?: string | null;
  image?: string | null;
  logo?: string | null;
  publisher?: string | null;
};

export type PollQuizResponses = {
  __typename: 'PollQuizResponses';
  feedCardId: string;
  pollQuizAnswers?: Array<PollQuizAnswer | null> | null;
  totalResponses: number;
};

export type PollQuizAnswer = {
  __typename: 'PollQuizAnswer';
  index: number;
  text: string;
  sortOrder: number;
  percentResponse: number;
};

export type AiGetChatHistoryOutput = {
  __typename: 'AiGetChatHistoryOutput';
  chatHistory?: Array<AiChatHistory | null> | null;
};

export type AiChatHistory = {
  __typename: 'AiChatHistory';
  type: string;
  content: string;
};

export type UnsplashSearchOutput = {
  __typename: 'UnsplashSearchOutput';
  total?: number | null;
  offset?: number | null;
  results?: Array<UnsplashSearchResult | null> | null;
};

export type UnsplashSearchResult = {
  __typename: 'UnsplashSearchResult';
  id: string;
  width?: number | null;
  height?: number | null;
  description?: string | null;
  alt_description?: string | null;
  urls?: UnsplashSearchResultUrls | null;
  links?: UnsplashSearchResultLinks | null;
  user?: UnsplashSearchResultUser | null;
};

export type UnsplashSearchResultUrls = {
  __typename: 'UnsplashSearchResultUrls';
  raw?: string | null;
  full?: string | null;
  regular?: string | null;
  small?: string | null;
  thumb?: string | null;
  small_s3?: string | null;
};

export type UnsplashSearchResultLinks = {
  __typename: 'UnsplashSearchResultLinks';
  self?: string | null;
  html?: string | null;
  download?: string | null;
  download_location?: string | null;
};

export type UnsplashSearchResultUser = {
  __typename: 'UnsplashSearchResultUser';
  id?: string | null;
  unsplashTrackDownload?: UnsplashTrackDownloadOutput | null;
  username?: string | null;
  name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
};

export type GiphySearchOutput = {
  __typename: 'GiphySearchOutput';
  total?: number | null;
  offset?: number | null;
  results?: Array<GiphySearchResult | null> | null;
};

export type GiphySearchResult = {
  __typename: 'GiphySearchResult';
  id: string;
  type?: string | null;
  url?: string | null;
  title?: string | null;
  alt_description?: string | null;
  images?: GiphySearchResultImages | null;
};

export type GiphySearchResultImages = {
  __typename: 'GiphySearchResultImages';
  original?: GiphySearchResultImagesOriginal | null;
  downsized?: GiphySearchResultImagesDownsized | null;
};

export type GiphySearchResultImagesOriginal = {
  __typename: 'GiphySearchResultImagesOriginal';
  width?: number | null;
  height?: number | null;
  url?: string | null;
};

export type GiphySearchResultImagesDownsized = {
  __typename: 'GiphySearchResultImagesDownsized';
  width?: number | null;
  height?: number | null;
  url?: string | null;
};

export type GiideAnalyticsOutput = {
  __typename: 'GiideAnalyticsOutput';
  details?: Array<GiideAnalyticsDetail | null> | null;
  feedCardDetails?: Array<FeedCard | null> | null;
  errorMessage?: string | null;
};

export type GiideAnalyticsDetail = {
  __typename: 'GiideAnalyticsDetail';
  timestamp: string;
  eventName: string;
  count: number;
  feedCardId?: string | null;
};

export type PaddleAccountDetailsOutput = {
  __typename: 'PaddleAccountDetailsOutput';
  errorMessage?: string | null;
  subscriptionId?: number | null;
  planId?: number | null;
  planName?: string | null;
  userId?: number | null;
  email?: string | null;
  marketingConsent?: boolean | null;
  updateUrl?: string | null;
  cancelUrl?: string | null;
  subscriptionState?: string | null;
  signupDate?: string | null;
  lastPaymentAmount?: number | null;
  lastPaymentCurrency?: string | null;
  lastPaymentDate?: string | null;
  paymentMethod?: string | null;
  cardType?: string | null;
  lastFourDigits?: string | null;
  expiryDate?: string | null;
  nextPaymentAmount?: number | null;
  nextPaymentCurrency?: string | null;
  nextPaymentDate?: string | null;
};

export type PaddleTransactionsOutput = {
  __typename: 'PaddleTransactionsOutput';
  errorMessage?: string | null;
  transactions?: Array<PaddleTransaction | null> | null;
};

export type PaddleTransaction = {
  __typename: 'PaddleTransaction';
  orderId?: string | null;
  checkoutId?: string | null;
  amount?: string | null;
  currency?: string | null;
  status?: string | null;
  createdAt?: string | null;
  giideUserID?: string | null;
  giideTenantID?: string | null;
  productId?: number | null;
  isSubscription?: boolean | null;
  isOneOff?: boolean | null;
  subscriptionId?: number | null;
  subscriptionStatus?: string | null;
  userId?: number | null;
  email?: string | null;
  marketingConsent?: boolean | null;
  receiptUrl?: string | null;
};

export type ModelGiideFilterInput = {
  id?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  tenantID?: ModelStringInput | null;
  publishState?: ModelPublishStateInput | null;
  unauthenticatedAccessAllowed?: ModelBooleanInput | null;
  owner?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  publishedAt?: ModelStringInput | null;
  previewedAt?: ModelStringInput | null;
  preview?: ModelBooleanInput | null;
  isInGiideStudioLibrary?: ModelBooleanInput | null;
  giideLibraryId?: ModelStringInput | null;
  useOwnDescription?: ModelBooleanInput | null;
  useOwnAuthorBio?: ModelBooleanInput | null;
  useGiideTones?: ModelBooleanInput | null;
  script?: ModelStringInput | null;
  hasChapters?: ModelBooleanInput | null;
  noindex?: ModelBooleanInput | null;
  embedCodeState?: ModelStringInput | null;
  embedCodeAllowedDomains?: ModelStringInput | null;
  and?: Array<ModelGiideFilterInput | null> | null;
  or?: Array<ModelGiideFilterInput | null> | null;
  not?: ModelGiideFilterInput | null;
};

export type ModelGiideConnection = {
  __typename: 'ModelGiideConnection';
  items: Array<Giide | null>;
  nextToken?: string | null;
};

export type ModelUserAudioLibraryFilterInput = {
  id?: ModelIDInput | null;
  audioUrl?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  durationSeconds?: ModelIntInput | null;
  tenantID?: ModelStringInput | null;
  title?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  userID?: ModelStringInput | null;
  state?: ModelStringInput | null;
  errorMessage?: ModelStringInput | null;
  errorMessageDisplayToUser?: ModelStringInput | null;
  originalFileExtension?: ModelStringInput | null;
  originalFileMimeType?: ModelStringInput | null;
  uploadSource?: ModelStringInput | null;
  and?: Array<ModelUserAudioLibraryFilterInput | null> | null;
  or?: Array<ModelUserAudioLibraryFilterInput | null> | null;
  not?: ModelUserAudioLibraryFilterInput | null;
};

export type ModelUserAudioLibraryConnection = {
  __typename: 'ModelUserAudioLibraryConnection';
  items: Array<UserAudioLibrary | null>;
  nextToken?: string | null;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type ModelStringKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type ModelUserGiidePermissionsFilterInput = {
  email?: ModelStringInput | null;
  giideID?: ModelStringInput | null;
  userID?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  tenantID?: ModelStringInput | null;
  and?: Array<ModelUserGiidePermissionsFilterInput | null> | null;
  or?: Array<ModelUserGiidePermissionsFilterInput | null> | null;
  not?: ModelUserGiidePermissionsFilterInput | null;
};

export type ModelUserGiidePermissionsConnection = {
  __typename: 'ModelUserGiidePermissionsConnection';
  items: Array<UserGiidePermissions | null>;
  nextToken?: string | null;
};

export type UserGiidePermissions = {
  __typename: 'UserGiidePermissions';
  email: string;
  giideID: string;
  userID?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  tenantID?: string | null;
};

export type AiStartChatRequestMutationVariables = {
  input: AiStartChatRequestInput;
};

export type AiStartChatRequestMutation = {
  aiStartChatRequest?: {
    __typename: 'AiStartChatRequestOutput';
    id?: string | null;
    success: boolean;
    error?: string | null;
  } | null;
};

export type AiGetChatResponseMutationVariables = {
  input: AiGetChatResponseInput;
};

export type AiGetChatResponseMutation = {
  aiGetChatResponse?: {
    __typename: 'AiGetChatResponseOutput';
    giideId: string;
    script: string;
  } | null;
};

export type HandleGiidePasswordsMutationVariables = {
  input: GiidePasswordInput;
};

export type HandleGiidePasswordsMutation = {
  handleGiidePasswords?: {
    __typename: 'GiidePasswordOutput';
    success: boolean;
    error?: string | null;
  } | null;
};

export type UnsplashTrackDownloadMutationVariables = {
  input?: UnsplashTrackDownloadInput | null;
};

export type UnsplashTrackDownloadMutation = {
  unsplashTrackDownload?: {
    __typename: 'UnsplashTrackDownloadOutput';
    type: string;
  } | null;
};

export type PaddleUpdateUserPlanMutationVariables = {
  input?: PaddleUpdateUserPlanInput | null;
};

export type PaddleUpdateUserPlanMutation = {
  paddleUpdateUserPlan?: {
    __typename: 'PaddleUpdateUserPlanOutput';
    planID: string;
    subscriptionID: string;
    error?: string | null;
  } | null;
};

export type CreateNewGiideMutation = {
  createNewGiide?: {
    __typename: 'CreateNewGiideOutput';
    giideID?: string | null;
    userID?: string | null;
    tenantID?: string | null;
    stepID?: string | null;
  } | null;
};

export type PublishGiideMutationVariables = {
  input?: PublishGiideInput | null;
};

export type PublishGiideMutation = {
  publishGiide?: {
    __typename: 'PublishGiideOutput';
    result?: string | null;
    error?: string | null;
    code?: string | null;
  } | null;
};

export type ExportVideoStartMutationVariables = {
  input?: ExportVideoUpdateInput | null;
};

export type ExportVideoStartMutation = {
  exportVideoStart?: {
    __typename: 'ExportVideoOutput';
    id: string;
    error?: boolean | null;
    status?: string | null;
    progress?: number | null;
  } | null;
};

export type ExportVideoUpdateMutationVariables = {
  input?: ExportVideoUpdateInput | null;
};

export type ExportVideoUpdateMutation = {
  exportVideoUpdate?: {
    __typename: 'ExportVideoOutput';
    id: string;
    error?: boolean | null;
    status?: string | null;
    progress?: number | null;
  } | null;
};

export type UpdateTranscriptContentMutationVariables = {
  input?: UpdateTranscriptContentInput | null;
};

export type UpdateTranscriptContentMutation = {
  updateTranscriptContent?: {
    __typename: 'GetTranscriptOutput';
    transcript?: string | null;
  } | null;
};

export type UpdateGiideEmbedSettingsMutationVariables = {
  input: inputUpdateGiideEmbedSettings;
};

export type UpdateGiideEmbedSettingsMutation = {
  updateGiideEmbedSettings?: {
    __typename: 'UpdateGiideEmbedSettingsResponses';
    id: string;
    owner: string;
    tenantID: string;
    embedCodeState: string;
    embedCodeAllowedDomains: Array<string | null>;
  } | null;
};

export type CopyGiideMutationVariables = {
  input: inputCopyGiide;
};

export type CopyGiideMutation = {
  copyGiide?: {
    __typename: 'CopyGiideResponses';
    newGiideId: string;
    owner: string;
    tenantID: string;
  } | null;
};

export type StepReorderMutationVariables = {
  input?: StepReorderInput | null;
};

export type StepReorderMutation = {
  stepReorder?: {
    __typename: 'StepReorderOutput';
    id?: string | null;
    success?: boolean | null;
    error?: string | null;
  } | null;
};

export type MobileAppEmailMutation = {
  mobileAppEmail?: {
    __typename: 'MobileAppEmailOutput';
    success: boolean;
  } | null;
};

export type UnlinkRecordingMutationVariables = {
  input?: UnlinkRecordingInput | null;
};

export type UnlinkRecordingMutation = {
  unlinkRecording?: {
    __typename: 'UnlinkRecordingOutput';
    success: boolean;
  } | null;
};

export type RelinkFeedCardMutationVariables = {
  input?: RelinkFeedCardInput | null;
};

export type RelinkFeedCardMutation = {
  relinkFeedCard?: {
    __typename: 'RelinkFeedCardOutput';
    success: boolean;
  } | null;
};

export type UnpublishGiideMutationVariables = {
  input?: UnpublishGiideInput | null;
};

export type UnpublishGiideMutation = {
  unpublishGiide?: {
    __typename: 'UnpublishGiideOutput';
    success: boolean;
    error?: string | null;
  } | null;
};

export type DeleteGiideAllMutationVariables = {
  input?: DeleteGiideAllInput | null;
};

export type DeleteGiideAllMutation = {
  deleteGiideAll?: {
    __typename: 'DeleteGiideAllOutput';
    success: boolean;
    error?: string | null;
  } | null;
};

export type UpdateUserProfileMutationVariables = {
  input: UpdateUserProfileInput;
};

export type UpdateUserProfileMutation = {
  updateUserProfile?: {
    __typename: 'UserProfileOutput';
    role: string;
    userID: string;
    email?: string | null;
    fullName?: string | null;
    title?: string | null;
    profileImageName?: string | null;
    profileImageService?: string | null;
    profileImageId?: string | null;
    preferences?: {
      __typename: 'GetUserProfilePreferencesOutput';
      firstLoginVideo?: boolean | null;
      dontShowPublishInfoTooltip?: boolean | null;
      dontShowFeedcardWordTooltip?: boolean | null;
      dontShowGetStartedModal?: boolean | null;
      dontShowTranscriptAnnouncementBanner?: boolean | null;
    } | null;
    giidesCreatedListFreePlan?: Array<{
      __typename: 'GetUserProfileGiidesCreatedListFreePlanOutput';
      createdAt: string;
      giideID: string;
      updatedAt: string;
    } | null> | null;
  } | null;
};

export type MoveFeedCardMutationVariables = {
  input?: MoveFeedCardInput | null;
};

export type MoveFeedCardMutation = {
  moveFeedCard?: {
    __typename: 'MoveFeedCardOutput';
    success: boolean;
    error?: string | null;
  } | null;
};

export type SelectRecordingFromLibraryMutationVariables = {
  input?: SelectRecordingFromLibraryInput | null;
};

export type SelectRecordingFromLibraryMutation = {
  selectRecordingFromLibrary?: {
    __typename: 'SelectRecordingFromLibraryOutput';
    success: boolean;
    error?: string | null;
    filePath?: string | null;
  } | null;
};

export type CopySampleAudioMutationVariables = {
  input?: CopySampleAudioInput | null;
};

export type CopySampleAudioMutation = {
  copySampleAudio?: {
    __typename: 'CopySampleAudioOutput';
    success: boolean;
    error?: string | null;
    filePath?: string | null;
  } | null;
};

export type InviteUserMutationVariables = {
  input?: InviteUserInput | null;
};

export type InviteUserMutation = {
  inviteUser?: {
    __typename: 'InviteUserOutput';
    success: boolean;
    error?: string | null;
  } | null;
};

export type DeleteAllInvitesMutationVariables = {
  input?: DeleteAllInvitesInput | null;
};

export type DeleteAllInvitesMutation = {
  deleteAllInvites?: {
    __typename: 'DeleteAllInvitesOutput';
    success: boolean;
    error?: string | null;
  } | null;
};

export type UpdateUserPlanTimeStampMutationVariables = {
  input: UpdateUserPlanTimeStampInput;
};

export type UpdateUserPlanTimeStampMutation = {
  updateUserPlanTimeStamp?: {
    __typename: 'GetPlanOutput';
    id?: string | null;
    versionID?: string | null;
    updatedAt?: string | null;
    createdAt?: string | null;
    price?: number | null;
    name?: string | null;
    features?: {
      __typename: 'PlanFeatures';
      giideMaxLengthAudio?: {
        __typename: 'PlanMaxLengthAudio';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        giideLengthInSeconds?: number | null;
        updatedAt?: string | null;
      } | null;
      giideMaxFileSizeAudio?: {
        __typename: 'PlanMaxFileSizeAudio';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        giideMaxFileSizeMBAudio?: number | null;
        updatedAt?: string | null;
      } | null;
      giideMaxNumberOfGiides?: {
        __typename: 'PlanMaxNumberOfGiides';
        createdAt?: string | null;
        hasLimit?: boolean | null;
        isActive?: boolean | null;
        limitAmount?: number | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
      chapters?: {
        __typename: 'PlanChapters';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        hasLimit?: boolean | null;
        maxNumberOfChapters?: number | null;
        allowChaptersWithFutureGiides?: boolean | null;
        allowChaptersWithExistingGiides?: boolean | null;
        updatedAt?: string | null;
      } | null;
      recording?: {
        __typename: 'PlanRecording';
        name?: string | null;
        createdAt?: string | null;
        hasBrowserRecording?: boolean | null;
        updatedAt?: string | null;
      } | null;
      embedCode?: {
        __typename: 'PlanEmbedCode';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        updatedAt?: string | null;
        allowEmbedCode?: boolean | null;
      } | null;
      pollQuizFeature?: {
        __typename: 'PlanPollQuizFeature';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        updatedAt?: string | null;
        allowFeature?: boolean | null;
      } | null;
      giidePasswordProtection?: {
        __typename: 'PlanGiidePasswordProtection';
        allowGiidePasswordProtection?: boolean | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
      giideDuplicate?: {
        __typename: 'PlanGiideDuplicate';
        allowGiideDuplicate?: boolean | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
    } | null;
    userID?: string | null;
    tenantID?: string | null;
    giidesCreatedListFreePlan?: Array<{
      __typename: 'GiidesCreated';
      giideID?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    giidesCreatedListProPlan?: Array<{
      __typename: 'GiidesCreated';
      giideID?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    subscriptionIDs?: Array<number | null> | null;
    accountStatus?: string | null;
    freeTrialEndDate?: string | null;
    totalGiidesCreated?: number | null;
    upgradePlans?: Array<number | null> | null;
    downgradePlans?: Array<number | null> | null;
    planChangeError?: string | null;
    paddlePlanID?: number | null;
  } | null;
};

export type CreateGiideMutationVariables = {
  input: CreateGiideInput;
  condition?: ModelGiideConditionInput | null;
};

export type CreateGiideMutation = {
  createGiide?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type UpdateGiideMutationVariables = {
  input: UpdateGiideInput;
  condition?: ModelGiideConditionInput | null;
};

export type UpdateGiideMutation = {
  updateGiide?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type DeleteGiideMutationVariables = {
  input: DeleteGiideInput;
  condition?: ModelGiideConditionInput | null;
};

export type DeleteGiideMutation = {
  deleteGiide?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type CreateStepMutationVariables = {
  input: CreateStepInput;
  condition?: ModelStepConditionInput | null;
};

export type CreateStepMutation = {
  createStep?: {
    __typename: 'Step';
    id: string;
    title: string;
    order: number;
    script?: string | null;
    giide: {
      __typename: 'Giide';
      id: string;
      title: string;
      description?: string | null;
      steps?: {
        __typename: 'ModelStepConnection';
        items: Array<{
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      tenantID?: string | null;
      speaker?: {
        __typename: 'Speaker';
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        bio?: string | null;
        title?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        profile?: string | null;
        headshotPath?: string | null;
      } | null;
      publishState?: PublishState | null;
      exportVideoState?: string | null;
      unauthenticatedAccessAllowed?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publishedAt?: string | null;
      publishedWithTranscript?: boolean | null;
      previewedAt?: string | null;
      cardDetails?: {
        __typename: 'CardDetails';
        cardColor?: string | null;
        cardShade?: string | null;
        thumbnailImg?: string | null;
        thumbnailCustomName?: string | null;
        thumbnailCustomPath?: string | null;
        thumbnailImageService?: ImageService | null;
        useCustomThumbnail?: boolean | null;
        colorLeft?: string | null;
        colorRight?: string | null;
        thumbnailLarge?: string | null;
        thumbnailSmall?: string | null;
      } | null;
      preview?: boolean | null;
      isInGiideStudioLibrary?: boolean | null;
      giideLibraryId?: string | null;
      useOwnDescription?: boolean | null;
      useOwnAuthorBio?: boolean | null;
      useGiideTones?: boolean | null;
      script?: string | null;
      hasChapters?: boolean | null;
      noindex?: boolean | null;
      embedCodeState?: string | null;
      embedCodeAllowedDomains?: Array<string | null> | null;
      passwordEnabled?: boolean | null;
    };
    tenantID?: string | null;
    open?: boolean | null;
    ownRecordingUploaded?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    recording?: {
      __typename: 'Recording';
      id: string;
      deleted?: boolean | null;
      length: number;
      step: {
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      };
      feedCards?: {
        __typename: 'ModelFeedCardConnection';
        items: Array<{
          __typename: 'FeedCard';
          nonLibraryGiideID?: string | null;
          id: string;
          source?: string | null;
          time: number;
          title?: string | null;
          type: CardType;
          url?: string | null;
          context?: string | null;
          affiliation?: string | null;
          text?: string | null;
          caption?: string | null;
          question?: string | null;
          feedCardIdForAnalytics?: string | null;
          questionHasCorrectAnswer?: boolean | null;
          customHeader?: string | null;
          questionType?: QuestionType | null;
          resourceType?: ResourceType | null;
          iconUrl?: string | null;
          imageUrl?: string | null;
          bold?: string | null;
          term?: string | null;
          tenantID?: string | null;
          numbered?: boolean | null;
          listItems?: Array<string | null> | null;
          author?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          expertise?: string | null;
          unlinked?: boolean | null;
          customImage?: string | null;
          customImageName?: string | null;
          giideId?: string | null;
          feedCardRecordingId?: string | null;
          htmlText?: string | null;
          imageService?: ImageService | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      transcriptResults?: {
        __typename: 'TranscriptResults';
        items: Array<{
          __typename: 'TranscriptItem';
          start_time?: string | null;
          end_time?: string | null;
          type: TranscriptItemType;
        }>;
        transcript?: string | null;
      } | null;
      tenantID?: string | null;
      filePath?: string | null;
      transcriptPath?: string | null;
      transcriptError?: string | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      giideId?: string | null;
      libraryRecordId?: string | null;
    } | null;
  } | null;
};

export type UpdateStepMutationVariables = {
  input: UpdateStepInput;
  condition?: ModelStepConditionInput | null;
};

export type UpdateStepMutation = {
  updateStep?: {
    __typename: 'Step';
    id: string;
    title: string;
    order: number;
    script?: string | null;
    giide: {
      __typename: 'Giide';
      id: string;
      title: string;
      description?: string | null;
      steps?: {
        __typename: 'ModelStepConnection';
        items: Array<{
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      tenantID?: string | null;
      speaker?: {
        __typename: 'Speaker';
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        bio?: string | null;
        title?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        profile?: string | null;
        headshotPath?: string | null;
      } | null;
      publishState?: PublishState | null;
      exportVideoState?: string | null;
      unauthenticatedAccessAllowed?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publishedAt?: string | null;
      publishedWithTranscript?: boolean | null;
      previewedAt?: string | null;
      cardDetails?: {
        __typename: 'CardDetails';
        cardColor?: string | null;
        cardShade?: string | null;
        thumbnailImg?: string | null;
        thumbnailCustomName?: string | null;
        thumbnailCustomPath?: string | null;
        thumbnailImageService?: ImageService | null;
        useCustomThumbnail?: boolean | null;
        colorLeft?: string | null;
        colorRight?: string | null;
        thumbnailLarge?: string | null;
        thumbnailSmall?: string | null;
      } | null;
      preview?: boolean | null;
      isInGiideStudioLibrary?: boolean | null;
      giideLibraryId?: string | null;
      useOwnDescription?: boolean | null;
      useOwnAuthorBio?: boolean | null;
      useGiideTones?: boolean | null;
      script?: string | null;
      hasChapters?: boolean | null;
      noindex?: boolean | null;
      embedCodeState?: string | null;
      embedCodeAllowedDomains?: Array<string | null> | null;
      passwordEnabled?: boolean | null;
    };
    tenantID?: string | null;
    open?: boolean | null;
    ownRecordingUploaded?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    recording?: {
      __typename: 'Recording';
      id: string;
      deleted?: boolean | null;
      length: number;
      step: {
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      };
      feedCards?: {
        __typename: 'ModelFeedCardConnection';
        items: Array<{
          __typename: 'FeedCard';
          nonLibraryGiideID?: string | null;
          id: string;
          source?: string | null;
          time: number;
          title?: string | null;
          type: CardType;
          url?: string | null;
          context?: string | null;
          affiliation?: string | null;
          text?: string | null;
          caption?: string | null;
          question?: string | null;
          feedCardIdForAnalytics?: string | null;
          questionHasCorrectAnswer?: boolean | null;
          customHeader?: string | null;
          questionType?: QuestionType | null;
          resourceType?: ResourceType | null;
          iconUrl?: string | null;
          imageUrl?: string | null;
          bold?: string | null;
          term?: string | null;
          tenantID?: string | null;
          numbered?: boolean | null;
          listItems?: Array<string | null> | null;
          author?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          expertise?: string | null;
          unlinked?: boolean | null;
          customImage?: string | null;
          customImageName?: string | null;
          giideId?: string | null;
          feedCardRecordingId?: string | null;
          htmlText?: string | null;
          imageService?: ImageService | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      transcriptResults?: {
        __typename: 'TranscriptResults';
        items: Array<{
          __typename: 'TranscriptItem';
          start_time?: string | null;
          end_time?: string | null;
          type: TranscriptItemType;
        }>;
        transcript?: string | null;
      } | null;
      tenantID?: string | null;
      filePath?: string | null;
      transcriptPath?: string | null;
      transcriptError?: string | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      giideId?: string | null;
      libraryRecordId?: string | null;
    } | null;
  } | null;
};

export type DeleteStepMutationVariables = {
  input: DeleteStepInput;
  condition?: ModelStepConditionInput | null;
};

export type DeleteStepMutation = {
  deleteStep?: {
    __typename: 'Step';
    id: string;
    title: string;
    order: number;
    script?: string | null;
    giide: {
      __typename: 'Giide';
      id: string;
      title: string;
      description?: string | null;
      steps?: {
        __typename: 'ModelStepConnection';
        items: Array<{
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      tenantID?: string | null;
      speaker?: {
        __typename: 'Speaker';
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        bio?: string | null;
        title?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        profile?: string | null;
        headshotPath?: string | null;
      } | null;
      publishState?: PublishState | null;
      exportVideoState?: string | null;
      unauthenticatedAccessAllowed?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publishedAt?: string | null;
      publishedWithTranscript?: boolean | null;
      previewedAt?: string | null;
      cardDetails?: {
        __typename: 'CardDetails';
        cardColor?: string | null;
        cardShade?: string | null;
        thumbnailImg?: string | null;
        thumbnailCustomName?: string | null;
        thumbnailCustomPath?: string | null;
        thumbnailImageService?: ImageService | null;
        useCustomThumbnail?: boolean | null;
        colorLeft?: string | null;
        colorRight?: string | null;
        thumbnailLarge?: string | null;
        thumbnailSmall?: string | null;
      } | null;
      preview?: boolean | null;
      isInGiideStudioLibrary?: boolean | null;
      giideLibraryId?: string | null;
      useOwnDescription?: boolean | null;
      useOwnAuthorBio?: boolean | null;
      useGiideTones?: boolean | null;
      script?: string | null;
      hasChapters?: boolean | null;
      noindex?: boolean | null;
      embedCodeState?: string | null;
      embedCodeAllowedDomains?: Array<string | null> | null;
      passwordEnabled?: boolean | null;
    };
    tenantID?: string | null;
    open?: boolean | null;
    ownRecordingUploaded?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    recording?: {
      __typename: 'Recording';
      id: string;
      deleted?: boolean | null;
      length: number;
      step: {
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      };
      feedCards?: {
        __typename: 'ModelFeedCardConnection';
        items: Array<{
          __typename: 'FeedCard';
          nonLibraryGiideID?: string | null;
          id: string;
          source?: string | null;
          time: number;
          title?: string | null;
          type: CardType;
          url?: string | null;
          context?: string | null;
          affiliation?: string | null;
          text?: string | null;
          caption?: string | null;
          question?: string | null;
          feedCardIdForAnalytics?: string | null;
          questionHasCorrectAnswer?: boolean | null;
          customHeader?: string | null;
          questionType?: QuestionType | null;
          resourceType?: ResourceType | null;
          iconUrl?: string | null;
          imageUrl?: string | null;
          bold?: string | null;
          term?: string | null;
          tenantID?: string | null;
          numbered?: boolean | null;
          listItems?: Array<string | null> | null;
          author?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          expertise?: string | null;
          unlinked?: boolean | null;
          customImage?: string | null;
          customImageName?: string | null;
          giideId?: string | null;
          feedCardRecordingId?: string | null;
          htmlText?: string | null;
          imageService?: ImageService | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      transcriptResults?: {
        __typename: 'TranscriptResults';
        items: Array<{
          __typename: 'TranscriptItem';
          start_time?: string | null;
          end_time?: string | null;
          type: TranscriptItemType;
        }>;
        transcript?: string | null;
      } | null;
      tenantID?: string | null;
      filePath?: string | null;
      transcriptPath?: string | null;
      transcriptError?: string | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      giideId?: string | null;
      libraryRecordId?: string | null;
    } | null;
  } | null;
};

export type CreateRecordingMutationVariables = {
  input: CreateRecordingInput;
  condition?: ModelRecordingConditionInput | null;
};

export type CreateRecordingMutation = {
  createRecording?: {
    __typename: 'Recording';
    id: string;
    deleted?: boolean | null;
    length: number;
    step: {
      __typename: 'Step';
      id: string;
      title: string;
      order: number;
      script?: string | null;
      giide: {
        __typename: 'Giide';
        id: string;
        title: string;
        description?: string | null;
        steps?: {
          __typename: 'ModelStepConnection';
          nextToken?: string | null;
        } | null;
        tenantID?: string | null;
        speaker?: {
          __typename: 'Speaker';
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          bio?: string | null;
          title?: string | null;
          profile?: string | null;
          headshotPath?: string | null;
        } | null;
        publishState?: PublishState | null;
        exportVideoState?: string | null;
        unauthenticatedAccessAllowed?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        publishedAt?: string | null;
        publishedWithTranscript?: boolean | null;
        previewedAt?: string | null;
        cardDetails?: {
          __typename: 'CardDetails';
          cardColor?: string | null;
          cardShade?: string | null;
          thumbnailImg?: string | null;
          thumbnailCustomName?: string | null;
          thumbnailCustomPath?: string | null;
          thumbnailImageService?: ImageService | null;
          useCustomThumbnail?: boolean | null;
          colorLeft?: string | null;
          colorRight?: string | null;
          thumbnailLarge?: string | null;
          thumbnailSmall?: string | null;
        } | null;
        preview?: boolean | null;
        isInGiideStudioLibrary?: boolean | null;
        giideLibraryId?: string | null;
        useOwnDescription?: boolean | null;
        useOwnAuthorBio?: boolean | null;
        useGiideTones?: boolean | null;
        script?: string | null;
        hasChapters?: boolean | null;
        noindex?: boolean | null;
        embedCodeState?: string | null;
        embedCodeAllowedDomains?: Array<string | null> | null;
        passwordEnabled?: boolean | null;
      };
      tenantID?: string | null;
      open?: boolean | null;
      ownRecordingUploaded?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      recording?: {
        __typename: 'Recording';
        id: string;
        deleted?: boolean | null;
        length: number;
        step: {
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        };
        feedCards?: {
          __typename: 'ModelFeedCardConnection';
          nextToken?: string | null;
        } | null;
        transcriptResults?: {
          __typename: 'TranscriptResults';
          transcript?: string | null;
        } | null;
        tenantID?: string | null;
        filePath?: string | null;
        transcriptPath?: string | null;
        transcriptError?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        giideId?: string | null;
        libraryRecordId?: string | null;
      } | null;
    };
    feedCards?: {
      __typename: 'ModelFeedCardConnection';
      items: Array<{
        __typename: 'FeedCard';
        nonLibraryGiideID?: string | null;
        id: string;
        source?: string | null;
        time: number;
        title?: string | null;
        type: CardType;
        url?: string | null;
        context?: string | null;
        affiliation?: string | null;
        text?: string | null;
        caption?: string | null;
        question?: string | null;
        feedCardIdForAnalytics?: string | null;
        questionHasCorrectAnswer?: boolean | null;
        customHeader?: string | null;
        questionType?: QuestionType | null;
        answerDetails?: {
          __typename: 'AnswerDetails';
          userAnswer?: string | null;
          userAnswerIsCorrect?: boolean | null;
          correctAnswerIndex?: number | null;
        } | null;
        resourceType?: ResourceType | null;
        iconUrl?: string | null;
        imageUrl?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        bold?: string | null;
        term?: string | null;
        tenantID?: string | null;
        numbered?: boolean | null;
        listItems?: Array<string | null> | null;
        author?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        expertise?: string | null;
        unlinked?: boolean | null;
        customImage?: string | null;
        customImageName?: string | null;
        giideId?: string | null;
        feedCardRecordingId?: string | null;
        imageDetails?: {
          __typename: 'FeedCardImageDetails';
          url?: string | null;
          description?: string | null;
          altDescription?: string | null;
          attributionUserName?: string | null;
          width?: number | null;
          height?: number | null;
          attributionFirstName?: string | null;
          attributionLastName?: string | null;
          attributionFullName?: string | null;
          caption?: string | null;
          imageTypeSelected?: FeedCardImageType | null;
        } | null;
        htmlText?: string | null;
        imageService?: ImageService | null;
        recording: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        };
      } | null>;
      nextToken?: string | null;
    } | null;
    transcriptResults?: {
      __typename: 'TranscriptResults';
      items: Array<{
        __typename: 'TranscriptItem';
        alternatives: Array<{
          __typename: 'TranscriptAlternatives';
          confidence: string;
          content: string;
        }>;
        start_time?: string | null;
        end_time?: string | null;
        type: TranscriptItemType;
      }>;
      transcript?: string | null;
    } | null;
    tenantID?: string | null;
    filePath?: string | null;
    transcriptPath?: string | null;
    transcriptError?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    giideId?: string | null;
    libraryRecordId?: string | null;
  } | null;
};

export type DeleteRecordingMutationVariables = {
  input: DeleteRecordingInput;
  condition?: ModelRecordingConditionInput | null;
};

export type DeleteRecordingMutation = {
  deleteRecording?: {
    __typename: 'Recording';
    id: string;
    deleted?: boolean | null;
    length: number;
    step: {
      __typename: 'Step';
      id: string;
      title: string;
      order: number;
      script?: string | null;
      giide: {
        __typename: 'Giide';
        id: string;
        title: string;
        description?: string | null;
        steps?: {
          __typename: 'ModelStepConnection';
          nextToken?: string | null;
        } | null;
        tenantID?: string | null;
        speaker?: {
          __typename: 'Speaker';
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          bio?: string | null;
          title?: string | null;
          profile?: string | null;
          headshotPath?: string | null;
        } | null;
        publishState?: PublishState | null;
        exportVideoState?: string | null;
        unauthenticatedAccessAllowed?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        publishedAt?: string | null;
        publishedWithTranscript?: boolean | null;
        previewedAt?: string | null;
        cardDetails?: {
          __typename: 'CardDetails';
          cardColor?: string | null;
          cardShade?: string | null;
          thumbnailImg?: string | null;
          thumbnailCustomName?: string | null;
          thumbnailCustomPath?: string | null;
          thumbnailImageService?: ImageService | null;
          useCustomThumbnail?: boolean | null;
          colorLeft?: string | null;
          colorRight?: string | null;
          thumbnailLarge?: string | null;
          thumbnailSmall?: string | null;
        } | null;
        preview?: boolean | null;
        isInGiideStudioLibrary?: boolean | null;
        giideLibraryId?: string | null;
        useOwnDescription?: boolean | null;
        useOwnAuthorBio?: boolean | null;
        useGiideTones?: boolean | null;
        script?: string | null;
        hasChapters?: boolean | null;
        noindex?: boolean | null;
        embedCodeState?: string | null;
        embedCodeAllowedDomains?: Array<string | null> | null;
        passwordEnabled?: boolean | null;
      };
      tenantID?: string | null;
      open?: boolean | null;
      ownRecordingUploaded?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      recording?: {
        __typename: 'Recording';
        id: string;
        deleted?: boolean | null;
        length: number;
        step: {
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        };
        feedCards?: {
          __typename: 'ModelFeedCardConnection';
          nextToken?: string | null;
        } | null;
        transcriptResults?: {
          __typename: 'TranscriptResults';
          transcript?: string | null;
        } | null;
        tenantID?: string | null;
        filePath?: string | null;
        transcriptPath?: string | null;
        transcriptError?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        giideId?: string | null;
        libraryRecordId?: string | null;
      } | null;
    };
    feedCards?: {
      __typename: 'ModelFeedCardConnection';
      items: Array<{
        __typename: 'FeedCard';
        nonLibraryGiideID?: string | null;
        id: string;
        source?: string | null;
        time: number;
        title?: string | null;
        type: CardType;
        url?: string | null;
        context?: string | null;
        affiliation?: string | null;
        text?: string | null;
        caption?: string | null;
        question?: string | null;
        feedCardIdForAnalytics?: string | null;
        questionHasCorrectAnswer?: boolean | null;
        customHeader?: string | null;
        questionType?: QuestionType | null;
        answerDetails?: {
          __typename: 'AnswerDetails';
          userAnswer?: string | null;
          userAnswerIsCorrect?: boolean | null;
          correctAnswerIndex?: number | null;
        } | null;
        resourceType?: ResourceType | null;
        iconUrl?: string | null;
        imageUrl?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        bold?: string | null;
        term?: string | null;
        tenantID?: string | null;
        numbered?: boolean | null;
        listItems?: Array<string | null> | null;
        author?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        expertise?: string | null;
        unlinked?: boolean | null;
        customImage?: string | null;
        customImageName?: string | null;
        giideId?: string | null;
        feedCardRecordingId?: string | null;
        imageDetails?: {
          __typename: 'FeedCardImageDetails';
          url?: string | null;
          description?: string | null;
          altDescription?: string | null;
          attributionUserName?: string | null;
          width?: number | null;
          height?: number | null;
          attributionFirstName?: string | null;
          attributionLastName?: string | null;
          attributionFullName?: string | null;
          caption?: string | null;
          imageTypeSelected?: FeedCardImageType | null;
        } | null;
        htmlText?: string | null;
        imageService?: ImageService | null;
        recording: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        };
      } | null>;
      nextToken?: string | null;
    } | null;
    transcriptResults?: {
      __typename: 'TranscriptResults';
      items: Array<{
        __typename: 'TranscriptItem';
        alternatives: Array<{
          __typename: 'TranscriptAlternatives';
          confidence: string;
          content: string;
        }>;
        start_time?: string | null;
        end_time?: string | null;
        type: TranscriptItemType;
      }>;
      transcript?: string | null;
    } | null;
    tenantID?: string | null;
    filePath?: string | null;
    transcriptPath?: string | null;
    transcriptError?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    giideId?: string | null;
    libraryRecordId?: string | null;
  } | null;
};

export type CreateUserAudioLibraryMutationVariables = {
  input: CreateUserAudioLibraryInput;
  condition?: ModelUserAudioLibraryConditionInput | null;
};

export type CreateUserAudioLibraryMutation = {
  createUserAudioLibrary?: {
    __typename: 'UserAudioLibrary';
    id: string;
    audioUrl?: string | null;
    createdAt?: string | null;
    durationSeconds?: number | null;
    tenantID?: string | null;
    title?: string | null;
    updatedAt?: string | null;
    userID: string;
    state?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    uploadSource?: string | null;
  } | null;
};

export type DeleteUserAudioLibraryMutationVariables = {
  input: DeleteUserAudioLibraryInput;
  condition?: ModelUserAudioLibraryConditionInput | null;
};

export type DeleteUserAudioLibraryMutation = {
  deleteUserAudioLibrary?: {
    __typename: 'UserAudioLibrary';
    id: string;
    audioUrl?: string | null;
    createdAt?: string | null;
    durationSeconds?: number | null;
    tenantID?: string | null;
    title?: string | null;
    updatedAt?: string | null;
    userID: string;
    state?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    uploadSource?: string | null;
  } | null;
};

export type CreateUserImageRecordMutationVariables = {
  input: CreateOrUpdateUserImageRecordInput;
};

export type CreateUserImageRecordMutation = {
  createUserImageRecord?: {
    __typename: 'UserImage';
    id: string;
    userID: string;
    feedCardId?: string | null;
    imageUrl?: string | null;
    type?: ImageUploadType | null;
    imageService?: ImageService | null;
    createdAt?: string | null;
    fileName?: string | null;
    state?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
  } | null;
};

export type UpdateUserImageRecordMutationVariables = {
  input: CreateOrUpdateUserImageRecordInput;
};

export type UpdateUserImageRecordMutation = {
  updateUserImageRecord?: {
    __typename: 'UserImage';
    id: string;
    userID: string;
    feedCardId?: string | null;
    imageUrl?: string | null;
    type?: ImageUploadType | null;
    imageService?: ImageService | null;
    createdAt?: string | null;
    fileName?: string | null;
    state?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
  } | null;
};

export type CreateFeedCardMutationVariables = {
  input: CreateFeedCardInput;
  condition?: ModelFeedCardConditionInput | null;
};

export type CreateFeedCardMutation = {
  createFeedCard?: {
    __typename: 'FeedCard';
    nonLibraryGiideID?: string | null;
    id: string;
    source?: string | null;
    time: number;
    title?: string | null;
    type: CardType;
    url?: string | null;
    context?: string | null;
    affiliation?: string | null;
    text?: string | null;
    caption?: string | null;
    question?: string | null;
    feedCardIdForAnalytics?: string | null;
    questionHasCorrectAnswer?: boolean | null;
    customHeader?: string | null;
    questionType?: QuestionType | null;
    answerDetails?: {
      __typename: 'AnswerDetails';
      answerOptions?: Array<{
        __typename: 'AnswerOption';
        index: number;
        sortOrder: number;
        text: string;
      }> | null;
      userAnswer?: string | null;
      userAnswerIsCorrect?: boolean | null;
      correctAnswerIndex?: number | null;
    } | null;
    resourceType?: ResourceType | null;
    iconUrl?: string | null;
    imageUrl?: string | null;
    socialUrls?: {
      __typename: 'SocialUrls';
      facebook?: string | null;
      twitter?: string | null;
      linkedin?: string | null;
      website?: string | null;
    } | null;
    bold?: string | null;
    term?: string | null;
    tenantID?: string | null;
    numbered?: boolean | null;
    listItems?: Array<string | null> | null;
    author?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    expertise?: string | null;
    unlinked?: boolean | null;
    customImage?: string | null;
    customImageName?: string | null;
    giideId?: string | null;
    feedCardRecordingId?: string | null;
    imageDetails?: {
      __typename: 'FeedCardImageDetails';
      url?: string | null;
      description?: string | null;
      altDescription?: string | null;
      attributionUserName?: string | null;
      width?: number | null;
      height?: number | null;
      attributionFirstName?: string | null;
      attributionLastName?: string | null;
      attributionFullName?: string | null;
      caption?: string | null;
      imageTypeSelected?: FeedCardImageType | null;
      userUploadedImageDetails?: {
        __typename: 'FeedCardUserUploadedImageDetails';
        customImageName?: string | null;
      } | null;
    } | null;
    htmlText?: string | null;
    imageService?: ImageService | null;
    recording: {
      __typename: 'Recording';
      id: string;
      deleted?: boolean | null;
      length: number;
      step: {
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      };
      feedCards?: {
        __typename: 'ModelFeedCardConnection';
        items: Array<{
          __typename: 'FeedCard';
          nonLibraryGiideID?: string | null;
          id: string;
          source?: string | null;
          time: number;
          title?: string | null;
          type: CardType;
          url?: string | null;
          context?: string | null;
          affiliation?: string | null;
          text?: string | null;
          caption?: string | null;
          question?: string | null;
          feedCardIdForAnalytics?: string | null;
          questionHasCorrectAnswer?: boolean | null;
          customHeader?: string | null;
          questionType?: QuestionType | null;
          resourceType?: ResourceType | null;
          iconUrl?: string | null;
          imageUrl?: string | null;
          bold?: string | null;
          term?: string | null;
          tenantID?: string | null;
          numbered?: boolean | null;
          listItems?: Array<string | null> | null;
          author?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          expertise?: string | null;
          unlinked?: boolean | null;
          customImage?: string | null;
          customImageName?: string | null;
          giideId?: string | null;
          feedCardRecordingId?: string | null;
          htmlText?: string | null;
          imageService?: ImageService | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      transcriptResults?: {
        __typename: 'TranscriptResults';
        items: Array<{
          __typename: 'TranscriptItem';
          start_time?: string | null;
          end_time?: string | null;
          type: TranscriptItemType;
        }>;
        transcript?: string | null;
      } | null;
      tenantID?: string | null;
      filePath?: string | null;
      transcriptPath?: string | null;
      transcriptError?: string | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      giideId?: string | null;
      libraryRecordId?: string | null;
    };
  } | null;
};

export type UpdateFeedCardMutationVariables = {
  input: UpdateFeedCardInput;
  condition?: ModelFeedCardConditionInput | null;
};

export type UpdateFeedCardMutation = {
  updateFeedCard?: {
    __typename: 'FeedCard';
    nonLibraryGiideID?: string | null;
    id: string;
    source?: string | null;
    time: number;
    title?: string | null;
    type: CardType;
    url?: string | null;
    context?: string | null;
    affiliation?: string | null;
    text?: string | null;
    caption?: string | null;
    question?: string | null;
    feedCardIdForAnalytics?: string | null;
    questionHasCorrectAnswer?: boolean | null;
    customHeader?: string | null;
    questionType?: QuestionType | null;
    answerDetails?: {
      __typename: 'AnswerDetails';
      answerOptions?: Array<{
        __typename: 'AnswerOption';
        index: number;
        sortOrder: number;
        text: string;
      }> | null;
      userAnswer?: string | null;
      userAnswerIsCorrect?: boolean | null;
      correctAnswerIndex?: number | null;
    } | null;
    resourceType?: ResourceType | null;
    iconUrl?: string | null;
    imageUrl?: string | null;
    socialUrls?: {
      __typename: 'SocialUrls';
      facebook?: string | null;
      twitter?: string | null;
      linkedin?: string | null;
      website?: string | null;
    } | null;
    bold?: string | null;
    term?: string | null;
    tenantID?: string | null;
    numbered?: boolean | null;
    listItems?: Array<string | null> | null;
    author?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    expertise?: string | null;
    unlinked?: boolean | null;
    customImage?: string | null;
    customImageName?: string | null;
    giideId?: string | null;
    feedCardRecordingId?: string | null;
    imageDetails?: {
      __typename: 'FeedCardImageDetails';
      url?: string | null;
      description?: string | null;
      altDescription?: string | null;
      attributionUserName?: string | null;
      width?: number | null;
      height?: number | null;
      attributionFirstName?: string | null;
      attributionLastName?: string | null;
      attributionFullName?: string | null;
      caption?: string | null;
      imageTypeSelected?: FeedCardImageType | null;
      userUploadedImageDetails?: {
        __typename: 'FeedCardUserUploadedImageDetails';
        customImageName?: string | null;
      } | null;
    } | null;
    htmlText?: string | null;
    imageService?: ImageService | null;
    recording: {
      __typename: 'Recording';
      id: string;
      deleted?: boolean | null;
      length: number;
      step: {
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      };
      feedCards?: {
        __typename: 'ModelFeedCardConnection';
        items: Array<{
          __typename: 'FeedCard';
          nonLibraryGiideID?: string | null;
          id: string;
          source?: string | null;
          time: number;
          title?: string | null;
          type: CardType;
          url?: string | null;
          context?: string | null;
          affiliation?: string | null;
          text?: string | null;
          caption?: string | null;
          question?: string | null;
          feedCardIdForAnalytics?: string | null;
          questionHasCorrectAnswer?: boolean | null;
          customHeader?: string | null;
          questionType?: QuestionType | null;
          resourceType?: ResourceType | null;
          iconUrl?: string | null;
          imageUrl?: string | null;
          bold?: string | null;
          term?: string | null;
          tenantID?: string | null;
          numbered?: boolean | null;
          listItems?: Array<string | null> | null;
          author?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          expertise?: string | null;
          unlinked?: boolean | null;
          customImage?: string | null;
          customImageName?: string | null;
          giideId?: string | null;
          feedCardRecordingId?: string | null;
          htmlText?: string | null;
          imageService?: ImageService | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      transcriptResults?: {
        __typename: 'TranscriptResults';
        items: Array<{
          __typename: 'TranscriptItem';
          start_time?: string | null;
          end_time?: string | null;
          type: TranscriptItemType;
        }>;
        transcript?: string | null;
      } | null;
      tenantID?: string | null;
      filePath?: string | null;
      transcriptPath?: string | null;
      transcriptError?: string | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      giideId?: string | null;
      libraryRecordId?: string | null;
    };
  } | null;
};

export type DeleteFeedCardMutationVariables = {
  input: DeleteFeedCardInput;
  condition?: ModelFeedCardConditionInput | null;
};

export type DeleteFeedCardMutation = {
  deleteFeedCard?: {
    __typename: 'FeedCard';
    nonLibraryGiideID?: string | null;
    id: string;
    source?: string | null;
    time: number;
    title?: string | null;
    type: CardType;
    url?: string | null;
    context?: string | null;
    affiliation?: string | null;
    text?: string | null;
    caption?: string | null;
    question?: string | null;
    feedCardIdForAnalytics?: string | null;
    questionHasCorrectAnswer?: boolean | null;
    customHeader?: string | null;
    questionType?: QuestionType | null;
    answerDetails?: {
      __typename: 'AnswerDetails';
      answerOptions?: Array<{
        __typename: 'AnswerOption';
        index: number;
        sortOrder: number;
        text: string;
      }> | null;
      userAnswer?: string | null;
      userAnswerIsCorrect?: boolean | null;
      correctAnswerIndex?: number | null;
    } | null;
    resourceType?: ResourceType | null;
    iconUrl?: string | null;
    imageUrl?: string | null;
    socialUrls?: {
      __typename: 'SocialUrls';
      facebook?: string | null;
      twitter?: string | null;
      linkedin?: string | null;
      website?: string | null;
    } | null;
    bold?: string | null;
    term?: string | null;
    tenantID?: string | null;
    numbered?: boolean | null;
    listItems?: Array<string | null> | null;
    author?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    expertise?: string | null;
    unlinked?: boolean | null;
    customImage?: string | null;
    customImageName?: string | null;
    giideId?: string | null;
    feedCardRecordingId?: string | null;
    imageDetails?: {
      __typename: 'FeedCardImageDetails';
      url?: string | null;
      description?: string | null;
      altDescription?: string | null;
      attributionUserName?: string | null;
      width?: number | null;
      height?: number | null;
      attributionFirstName?: string | null;
      attributionLastName?: string | null;
      attributionFullName?: string | null;
      caption?: string | null;
      imageTypeSelected?: FeedCardImageType | null;
      userUploadedImageDetails?: {
        __typename: 'FeedCardUserUploadedImageDetails';
        customImageName?: string | null;
      } | null;
    } | null;
    htmlText?: string | null;
    imageService?: ImageService | null;
    recording: {
      __typename: 'Recording';
      id: string;
      deleted?: boolean | null;
      length: number;
      step: {
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      };
      feedCards?: {
        __typename: 'ModelFeedCardConnection';
        items: Array<{
          __typename: 'FeedCard';
          nonLibraryGiideID?: string | null;
          id: string;
          source?: string | null;
          time: number;
          title?: string | null;
          type: CardType;
          url?: string | null;
          context?: string | null;
          affiliation?: string | null;
          text?: string | null;
          caption?: string | null;
          question?: string | null;
          feedCardIdForAnalytics?: string | null;
          questionHasCorrectAnswer?: boolean | null;
          customHeader?: string | null;
          questionType?: QuestionType | null;
          resourceType?: ResourceType | null;
          iconUrl?: string | null;
          imageUrl?: string | null;
          bold?: string | null;
          term?: string | null;
          tenantID?: string | null;
          numbered?: boolean | null;
          listItems?: Array<string | null> | null;
          author?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          expertise?: string | null;
          unlinked?: boolean | null;
          customImage?: string | null;
          customImageName?: string | null;
          giideId?: string | null;
          feedCardRecordingId?: string | null;
          htmlText?: string | null;
          imageService?: ImageService | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      transcriptResults?: {
        __typename: 'TranscriptResults';
        items: Array<{
          __typename: 'TranscriptItem';
          start_time?: string | null;
          end_time?: string | null;
          type: TranscriptItemType;
        }>;
        transcript?: string | null;
      } | null;
      tenantID?: string | null;
      filePath?: string | null;
      transcriptPath?: string | null;
      transcriptError?: string | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      giideId?: string | null;
      libraryRecordId?: string | null;
    };
  } | null;
};

export type DeleteFeedCardResourcesMutationVariables = {
  input: DeleteFeedCardInput;
};

export type DeleteFeedCardResourcesMutation = {
  deleteFeedCardResources?: {
    __typename: 'DeleteFeedCardOutput';
    success: boolean;
    error?: string | null;
  } | null;
};

export type UpdateRecordingMutationVariables = {
  input: UpdateRecordingInput;
  condition?: ModelRecordingConditionInput | null;
};

export type UpdateRecordingMutation = {
  updateRecording?: {
    __typename: 'Recording';
    id: string;
    deleted?: boolean | null;
    length: number;
    step: {
      __typename: 'Step';
      id: string;
      title: string;
      order: number;
      script?: string | null;
      giide: {
        __typename: 'Giide';
        id: string;
        title: string;
        description?: string | null;
        steps?: {
          __typename: 'ModelStepConnection';
          nextToken?: string | null;
        } | null;
        tenantID?: string | null;
        speaker?: {
          __typename: 'Speaker';
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          bio?: string | null;
          title?: string | null;
          profile?: string | null;
          headshotPath?: string | null;
        } | null;
        publishState?: PublishState | null;
        exportVideoState?: string | null;
        unauthenticatedAccessAllowed?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        publishedAt?: string | null;
        publishedWithTranscript?: boolean | null;
        previewedAt?: string | null;
        cardDetails?: {
          __typename: 'CardDetails';
          cardColor?: string | null;
          cardShade?: string | null;
          thumbnailImg?: string | null;
          thumbnailCustomName?: string | null;
          thumbnailCustomPath?: string | null;
          thumbnailImageService?: ImageService | null;
          useCustomThumbnail?: boolean | null;
          colorLeft?: string | null;
          colorRight?: string | null;
          thumbnailLarge?: string | null;
          thumbnailSmall?: string | null;
        } | null;
        preview?: boolean | null;
        isInGiideStudioLibrary?: boolean | null;
        giideLibraryId?: string | null;
        useOwnDescription?: boolean | null;
        useOwnAuthorBio?: boolean | null;
        useGiideTones?: boolean | null;
        script?: string | null;
        hasChapters?: boolean | null;
        noindex?: boolean | null;
        embedCodeState?: string | null;
        embedCodeAllowedDomains?: Array<string | null> | null;
        passwordEnabled?: boolean | null;
      };
      tenantID?: string | null;
      open?: boolean | null;
      ownRecordingUploaded?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      recording?: {
        __typename: 'Recording';
        id: string;
        deleted?: boolean | null;
        length: number;
        step: {
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        };
        feedCards?: {
          __typename: 'ModelFeedCardConnection';
          nextToken?: string | null;
        } | null;
        transcriptResults?: {
          __typename: 'TranscriptResults';
          transcript?: string | null;
        } | null;
        tenantID?: string | null;
        filePath?: string | null;
        transcriptPath?: string | null;
        transcriptError?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        giideId?: string | null;
        libraryRecordId?: string | null;
      } | null;
    };
    feedCards?: {
      __typename: 'ModelFeedCardConnection';
      items: Array<{
        __typename: 'FeedCard';
        nonLibraryGiideID?: string | null;
        id: string;
        source?: string | null;
        time: number;
        title?: string | null;
        type: CardType;
        url?: string | null;
        context?: string | null;
        affiliation?: string | null;
        text?: string | null;
        caption?: string | null;
        question?: string | null;
        feedCardIdForAnalytics?: string | null;
        questionHasCorrectAnswer?: boolean | null;
        customHeader?: string | null;
        questionType?: QuestionType | null;
        answerDetails?: {
          __typename: 'AnswerDetails';
          userAnswer?: string | null;
          userAnswerIsCorrect?: boolean | null;
          correctAnswerIndex?: number | null;
        } | null;
        resourceType?: ResourceType | null;
        iconUrl?: string | null;
        imageUrl?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        bold?: string | null;
        term?: string | null;
        tenantID?: string | null;
        numbered?: boolean | null;
        listItems?: Array<string | null> | null;
        author?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        expertise?: string | null;
        unlinked?: boolean | null;
        customImage?: string | null;
        customImageName?: string | null;
        giideId?: string | null;
        feedCardRecordingId?: string | null;
        imageDetails?: {
          __typename: 'FeedCardImageDetails';
          url?: string | null;
          description?: string | null;
          altDescription?: string | null;
          attributionUserName?: string | null;
          width?: number | null;
          height?: number | null;
          attributionFirstName?: string | null;
          attributionLastName?: string | null;
          attributionFullName?: string | null;
          caption?: string | null;
          imageTypeSelected?: FeedCardImageType | null;
        } | null;
        htmlText?: string | null;
        imageService?: ImageService | null;
        recording: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        };
      } | null>;
      nextToken?: string | null;
    } | null;
    transcriptResults?: {
      __typename: 'TranscriptResults';
      items: Array<{
        __typename: 'TranscriptItem';
        alternatives: Array<{
          __typename: 'TranscriptAlternatives';
          confidence: string;
          content: string;
        }>;
        start_time?: string | null;
        end_time?: string | null;
        type: TranscriptItemType;
      }>;
      transcript?: string | null;
    } | null;
    tenantID?: string | null;
    filePath?: string | null;
    transcriptPath?: string | null;
    transcriptError?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    giideId?: string | null;
    libraryRecordId?: string | null;
  } | null;
};

export type UpdateUserAudioLibraryMutationVariables = {
  input: UpdateUserAudioLibraryInput;
  condition?: ModelUserAudioLibraryConditionInput | null;
};

export type UpdateUserAudioLibraryMutation = {
  updateUserAudioLibrary?: {
    __typename: 'UserAudioLibrary';
    id: string;
    audioUrl?: string | null;
    createdAt?: string | null;
    durationSeconds?: number | null;
    tenantID?: string | null;
    title?: string | null;
    updatedAt?: string | null;
    userID: string;
    state?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    uploadSource?: string | null;
  } | null;
};

export type CustomQuery = {
  custom: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  };
};

export type GetUrlQueryVariables = {
  input?: GetUrlInput | null;
};

export type GetUrlQuery = {
  getUrl?: {
    __typename: 'GetUrlOutput';
    success: boolean;
    error?: string | null;
    url?: string | null;
    fields?: string | null;
  } | null;
};

export type GetUrlMetaDataQueryVariables = {
  url: string;
};

export type GetUrlMetaDataQuery = {
  getUrlMetaData?: {
    __typename: 'GetUrlMetaDataOutput';
    title?: string | null;
    image?: string | null;
    logo?: string | null;
    publisher?: string | null;
  } | null;
};

export type GetPollQuizResponsesStudioQueryVariables = {
  giideId: string;
};

export type GetPollQuizResponsesStudioQuery = {
  getPollQuizResponsesStudio?: Array<{
    __typename: 'PollQuizResponses';
    feedCardId: string;
    pollQuizAnswers?: Array<{
      __typename: 'PollQuizAnswer';
      index: number;
      text: string;
      sortOrder: number;
      percentResponse: number;
    } | null> | null;
    totalResponses: number;
  } | null> | null;
};

export type GetPlanQuery = {
  getPlan?: {
    __typename: 'GetPlanOutput';
    id?: string | null;
    versionID?: string | null;
    updatedAt?: string | null;
    createdAt?: string | null;
    price?: number | null;
    name?: string | null;
    features?: {
      __typename: 'PlanFeatures';
      giideMaxLengthAudio?: {
        __typename: 'PlanMaxLengthAudio';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        giideLengthInSeconds?: number | null;
        updatedAt?: string | null;
      } | null;
      giideMaxFileSizeAudio?: {
        __typename: 'PlanMaxFileSizeAudio';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        giideMaxFileSizeMBAudio?: number | null;
        updatedAt?: string | null;
      } | null;
      giideMaxNumberOfGiides?: {
        __typename: 'PlanMaxNumberOfGiides';
        createdAt?: string | null;
        hasLimit?: boolean | null;
        isActive?: boolean | null;
        limitAmount?: number | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
      chapters?: {
        __typename: 'PlanChapters';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        hasLimit?: boolean | null;
        maxNumberOfChapters?: number | null;
        allowChaptersWithFutureGiides?: boolean | null;
        allowChaptersWithExistingGiides?: boolean | null;
        updatedAt?: string | null;
      } | null;
      recording?: {
        __typename: 'PlanRecording';
        name?: string | null;
        createdAt?: string | null;
        hasBrowserRecording?: boolean | null;
        updatedAt?: string | null;
      } | null;
      embedCode?: {
        __typename: 'PlanEmbedCode';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        updatedAt?: string | null;
        allowEmbedCode?: boolean | null;
      } | null;
      pollQuizFeature?: {
        __typename: 'PlanPollQuizFeature';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        updatedAt?: string | null;
        allowFeature?: boolean | null;
      } | null;
      giidePasswordProtection?: {
        __typename: 'PlanGiidePasswordProtection';
        allowGiidePasswordProtection?: boolean | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
      giideDuplicate?: {
        __typename: 'PlanGiideDuplicate';
        allowGiideDuplicate?: boolean | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
    } | null;
    userID?: string | null;
    tenantID?: string | null;
    giidesCreatedListFreePlan?: Array<{
      __typename: 'GiidesCreated';
      giideID?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    giidesCreatedListProPlan?: Array<{
      __typename: 'GiidesCreated';
      giideID?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    subscriptionIDs?: Array<number | null> | null;
    accountStatus?: string | null;
    freeTrialEndDate?: string | null;
    totalGiidesCreated?: number | null;
    upgradePlans?: Array<number | null> | null;
    downgradePlans?: Array<number | null> | null;
    planChangeError?: string | null;
    paddlePlanID?: number | null;
  } | null;
};

export type GetAiChatHistoryQueryVariables = {
  giideId: string;
};

export type GetAiChatHistoryQuery = {
  getAiChatHistory?: {
    __typename: 'AiGetChatHistoryOutput';
    chatHistory?: Array<{
      __typename: 'AiChatHistory';
      type: string;
      content: string;
    } | null> | null;
  } | null;
};

export type GetUserProfileQuery = {
  getUserProfile?: {
    __typename: 'UserProfileOutput';
    role: string;
    userID: string;
    email?: string | null;
    fullName?: string | null;
    title?: string | null;
    profileImageName?: string | null;
    profileImageService?: string | null;
    profileImageId?: string | null;
    preferences?: {
      __typename: 'GetUserProfilePreferencesOutput';
      firstLoginVideo?: boolean | null;
      dontShowPublishInfoTooltip?: boolean | null;
      dontShowFeedcardWordTooltip?: boolean | null;
      dontShowGetStartedModal?: boolean | null;
      dontShowTranscriptAnnouncementBanner?: boolean | null;
    } | null;
    giidesCreatedListFreePlan?: Array<{
      __typename: 'GetUserProfileGiidesCreatedListFreePlanOutput';
      createdAt: string;
      giideID: string;
      updatedAt: string;
    } | null> | null;
  } | null;
};

export type GetTranscriptQueryVariables = {
  giideID: string;
  recordingID: string;
};

export type GetTranscriptQuery = {
  getTranscript?: {
    __typename: 'GetTranscriptOutput';
    transcript?: string | null;
  } | null;
};

export type UnsplashSearchQueryVariables = {
  query: string;
  page: number;
};

export type UnsplashSearchQuery = {
  unsplashSearch?: {
    __typename: 'UnsplashSearchOutput';
    total?: number | null;
    offset?: number | null;
    results?: Array<{
      __typename: 'UnsplashSearchResult';
      id: string;
      width?: number | null;
      height?: number | null;
      description?: string | null;
      alt_description?: string | null;
      urls?: {
        __typename: 'UnsplashSearchResultUrls';
        raw?: string | null;
        full?: string | null;
        regular?: string | null;
        small?: string | null;
        thumb?: string | null;
        small_s3?: string | null;
      } | null;
      links?: {
        __typename: 'UnsplashSearchResultLinks';
        self?: string | null;
        html?: string | null;
        download?: string | null;
        download_location?: string | null;
      } | null;
      user?: {
        __typename: 'UnsplashSearchResultUser';
        id?: string | null;
        unsplashTrackDownload?: {
          __typename: 'UnsplashTrackDownloadOutput';
          type: string;
        } | null;
        username?: string | null;
        name?: string | null;
        first_name?: string | null;
        last_name?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GiphySearchQueryVariables = {
  query: string;
  page: number;
};

export type GiphySearchQuery = {
  giphySearch?: {
    __typename: 'GiphySearchOutput';
    total?: number | null;
    offset?: number | null;
    results?: Array<{
      __typename: 'GiphySearchResult';
      id: string;
      type?: string | null;
      url?: string | null;
      title?: string | null;
      alt_description?: string | null;
      images?: {
        __typename: 'GiphySearchResultImages';
        original?: {
          __typename: 'GiphySearchResultImagesOriginal';
          width?: number | null;
          height?: number | null;
          url?: string | null;
        } | null;
        downsized?: {
          __typename: 'GiphySearchResultImagesDownsized';
          width?: number | null;
          height?: number | null;
          url?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetGiideAnalyticsQueryVariables = {
  userID: string;
  tenantID: string;
  giideID: string;
  period: number;
  grouping: string;
  timezoneOffset: number;
};

export type GetGiideAnalyticsQuery = {
  getGiideAnalytics?: {
    __typename: 'GiideAnalyticsOutput';
    details?: Array<{
      __typename: 'GiideAnalyticsDetail';
      timestamp: string;
      eventName: string;
      count: number;
      feedCardId?: string | null;
    } | null> | null;
    feedCardDetails?: Array<{
      __typename: 'FeedCard';
      nonLibraryGiideID?: string | null;
      id: string;
      source?: string | null;
      time: number;
      title?: string | null;
      type: CardType;
      url?: string | null;
      context?: string | null;
      affiliation?: string | null;
      text?: string | null;
      caption?: string | null;
      question?: string | null;
      feedCardIdForAnalytics?: string | null;
      questionHasCorrectAnswer?: boolean | null;
      customHeader?: string | null;
      questionType?: QuestionType | null;
      answerDetails?: {
        __typename: 'AnswerDetails';
        answerOptions?: Array<{
          __typename: 'AnswerOption';
          index: number;
          sortOrder: number;
          text: string;
        }> | null;
        userAnswer?: string | null;
        userAnswerIsCorrect?: boolean | null;
        correctAnswerIndex?: number | null;
      } | null;
      resourceType?: ResourceType | null;
      iconUrl?: string | null;
      imageUrl?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      bold?: string | null;
      term?: string | null;
      tenantID?: string | null;
      numbered?: boolean | null;
      listItems?: Array<string | null> | null;
      author?: string | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      expertise?: string | null;
      unlinked?: boolean | null;
      customImage?: string | null;
      customImageName?: string | null;
      giideId?: string | null;
      feedCardRecordingId?: string | null;
      imageDetails?: {
        __typename: 'FeedCardImageDetails';
        url?: string | null;
        description?: string | null;
        altDescription?: string | null;
        attributionUserName?: string | null;
        width?: number | null;
        height?: number | null;
        attributionFirstName?: string | null;
        attributionLastName?: string | null;
        attributionFullName?: string | null;
        caption?: string | null;
        imageTypeSelected?: FeedCardImageType | null;
        userUploadedImageDetails?: {
          __typename: 'FeedCardUserUploadedImageDetails';
          customImageName?: string | null;
        } | null;
      } | null;
      htmlText?: string | null;
      imageService?: ImageService | null;
      recording: {
        __typename: 'Recording';
        id: string;
        deleted?: boolean | null;
        length: number;
        step: {
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        };
        feedCards?: {
          __typename: 'ModelFeedCardConnection';
          nextToken?: string | null;
        } | null;
        transcriptResults?: {
          __typename: 'TranscriptResults';
          transcript?: string | null;
        } | null;
        tenantID?: string | null;
        filePath?: string | null;
        transcriptPath?: string | null;
        transcriptError?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        giideId?: string | null;
        libraryRecordId?: string | null;
      };
    } | null> | null;
    errorMessage?: string | null;
  } | null;
};

export type GetGiidePaddleAccountDetailsQueryVariables = {
  subscriptionId: number;
};

export type GetGiidePaddleAccountDetailsQuery = {
  getGiidePaddleAccountDetails?: {
    __typename: 'PaddleAccountDetailsOutput';
    errorMessage?: string | null;
    subscriptionId?: number | null;
    planId?: number | null;
    planName?: string | null;
    userId?: number | null;
    email?: string | null;
    marketingConsent?: boolean | null;
    updateUrl?: string | null;
    cancelUrl?: string | null;
    subscriptionState?: string | null;
    signupDate?: string | null;
    lastPaymentAmount?: number | null;
    lastPaymentCurrency?: string | null;
    lastPaymentDate?: string | null;
    paymentMethod?: string | null;
    cardType?: string | null;
    lastFourDigits?: string | null;
    expiryDate?: string | null;
    nextPaymentAmount?: number | null;
    nextPaymentCurrency?: string | null;
    nextPaymentDate?: string | null;
  } | null;
};

export type GetGiidePaddleTransactionsQueryVariables = {
  subscriptionId: number;
};

export type GetGiidePaddleTransactionsQuery = {
  getGiidePaddleTransactions?: {
    __typename: 'PaddleTransactionsOutput';
    errorMessage?: string | null;
    transactions?: Array<{
      __typename: 'PaddleTransaction';
      orderId?: string | null;
      checkoutId?: string | null;
      amount?: string | null;
      currency?: string | null;
      status?: string | null;
      createdAt?: string | null;
      giideUserID?: string | null;
      giideTenantID?: string | null;
      productId?: number | null;
      isSubscription?: boolean | null;
      isOneOff?: boolean | null;
      subscriptionId?: number | null;
      subscriptionStatus?: string | null;
      userId?: number | null;
      email?: string | null;
      marketingConsent?: boolean | null;
      receiptUrl?: string | null;
    } | null> | null;
  } | null;
};

export type GetGiideQueryVariables = {
  id: string;
};

export type GetGiideQuery = {
  getGiide?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type GetGiidePlayerDataQueryVariables = {
  id: string;
};

export type GetGiidePlayerDataQuery = {
  getGiidePlayerData?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type ListGiidesQueryVariables = {
  filter?: ModelGiideFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListGiidesQuery = {
  listGiides?: {
    __typename: 'ModelGiideConnection';
    items: Array<{
      __typename: 'Giide';
      id: string;
      title: string;
      description?: string | null;
      steps?: {
        __typename: 'ModelStepConnection';
        items: Array<{
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      tenantID?: string | null;
      speaker?: {
        __typename: 'Speaker';
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        bio?: string | null;
        title?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        profile?: string | null;
        headshotPath?: string | null;
      } | null;
      publishState?: PublishState | null;
      exportVideoState?: string | null;
      unauthenticatedAccessAllowed?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publishedAt?: string | null;
      publishedWithTranscript?: boolean | null;
      previewedAt?: string | null;
      cardDetails?: {
        __typename: 'CardDetails';
        cardColor?: string | null;
        cardShade?: string | null;
        thumbnailImg?: string | null;
        thumbnailCustomName?: string | null;
        thumbnailCustomPath?: string | null;
        thumbnailImageService?: ImageService | null;
        useCustomThumbnail?: boolean | null;
        colorLeft?: string | null;
        colorRight?: string | null;
        thumbnailLarge?: string | null;
        thumbnailSmall?: string | null;
      } | null;
      preview?: boolean | null;
      isInGiideStudioLibrary?: boolean | null;
      giideLibraryId?: string | null;
      useOwnDescription?: boolean | null;
      useOwnAuthorBio?: boolean | null;
      useGiideTones?: boolean | null;
      script?: string | null;
      hasChapters?: boolean | null;
      noindex?: boolean | null;
      embedCodeState?: string | null;
      embedCodeAllowedDomains?: Array<string | null> | null;
      passwordEnabled?: boolean | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type GetRecordingQueryVariables = {
  id: string;
};

export type GetRecordingQuery = {
  getRecording?: {
    __typename: 'Recording';
    id: string;
    deleted?: boolean | null;
    length: number;
    step: {
      __typename: 'Step';
      id: string;
      title: string;
      order: number;
      script?: string | null;
      giide: {
        __typename: 'Giide';
        id: string;
        title: string;
        description?: string | null;
        steps?: {
          __typename: 'ModelStepConnection';
          nextToken?: string | null;
        } | null;
        tenantID?: string | null;
        speaker?: {
          __typename: 'Speaker';
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          bio?: string | null;
          title?: string | null;
          profile?: string | null;
          headshotPath?: string | null;
        } | null;
        publishState?: PublishState | null;
        exportVideoState?: string | null;
        unauthenticatedAccessAllowed?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        publishedAt?: string | null;
        publishedWithTranscript?: boolean | null;
        previewedAt?: string | null;
        cardDetails?: {
          __typename: 'CardDetails';
          cardColor?: string | null;
          cardShade?: string | null;
          thumbnailImg?: string | null;
          thumbnailCustomName?: string | null;
          thumbnailCustomPath?: string | null;
          thumbnailImageService?: ImageService | null;
          useCustomThumbnail?: boolean | null;
          colorLeft?: string | null;
          colorRight?: string | null;
          thumbnailLarge?: string | null;
          thumbnailSmall?: string | null;
        } | null;
        preview?: boolean | null;
        isInGiideStudioLibrary?: boolean | null;
        giideLibraryId?: string | null;
        useOwnDescription?: boolean | null;
        useOwnAuthorBio?: boolean | null;
        useGiideTones?: boolean | null;
        script?: string | null;
        hasChapters?: boolean | null;
        noindex?: boolean | null;
        embedCodeState?: string | null;
        embedCodeAllowedDomains?: Array<string | null> | null;
        passwordEnabled?: boolean | null;
      };
      tenantID?: string | null;
      open?: boolean | null;
      ownRecordingUploaded?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      recording?: {
        __typename: 'Recording';
        id: string;
        deleted?: boolean | null;
        length: number;
        step: {
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        };
        feedCards?: {
          __typename: 'ModelFeedCardConnection';
          nextToken?: string | null;
        } | null;
        transcriptResults?: {
          __typename: 'TranscriptResults';
          transcript?: string | null;
        } | null;
        tenantID?: string | null;
        filePath?: string | null;
        transcriptPath?: string | null;
        transcriptError?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        giideId?: string | null;
        libraryRecordId?: string | null;
      } | null;
    };
    feedCards?: {
      __typename: 'ModelFeedCardConnection';
      items: Array<{
        __typename: 'FeedCard';
        nonLibraryGiideID?: string | null;
        id: string;
        source?: string | null;
        time: number;
        title?: string | null;
        type: CardType;
        url?: string | null;
        context?: string | null;
        affiliation?: string | null;
        text?: string | null;
        caption?: string | null;
        question?: string | null;
        feedCardIdForAnalytics?: string | null;
        questionHasCorrectAnswer?: boolean | null;
        customHeader?: string | null;
        questionType?: QuestionType | null;
        answerDetails?: {
          __typename: 'AnswerDetails';
          userAnswer?: string | null;
          userAnswerIsCorrect?: boolean | null;
          correctAnswerIndex?: number | null;
        } | null;
        resourceType?: ResourceType | null;
        iconUrl?: string | null;
        imageUrl?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        bold?: string | null;
        term?: string | null;
        tenantID?: string | null;
        numbered?: boolean | null;
        listItems?: Array<string | null> | null;
        author?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        expertise?: string | null;
        unlinked?: boolean | null;
        customImage?: string | null;
        customImageName?: string | null;
        giideId?: string | null;
        feedCardRecordingId?: string | null;
        imageDetails?: {
          __typename: 'FeedCardImageDetails';
          url?: string | null;
          description?: string | null;
          altDescription?: string | null;
          attributionUserName?: string | null;
          width?: number | null;
          height?: number | null;
          attributionFirstName?: string | null;
          attributionLastName?: string | null;
          attributionFullName?: string | null;
          caption?: string | null;
          imageTypeSelected?: FeedCardImageType | null;
        } | null;
        htmlText?: string | null;
        imageService?: ImageService | null;
        recording: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        };
      } | null>;
      nextToken?: string | null;
    } | null;
    transcriptResults?: {
      __typename: 'TranscriptResults';
      items: Array<{
        __typename: 'TranscriptItem';
        alternatives: Array<{
          __typename: 'TranscriptAlternatives';
          confidence: string;
          content: string;
        }>;
        start_time?: string | null;
        end_time?: string | null;
        type: TranscriptItemType;
      }>;
      transcript?: string | null;
    } | null;
    tenantID?: string | null;
    filePath?: string | null;
    transcriptPath?: string | null;
    transcriptError?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    giideId?: string | null;
    libraryRecordId?: string | null;
  } | null;
};

export type GetUserAudioLibraryQueryVariables = {
  id: string;
};

export type GetUserAudioLibraryQuery = {
  getUserAudioLibrary?: {
    __typename: 'UserAudioLibrary';
    id: string;
    audioUrl?: string | null;
    createdAt?: string | null;
    durationSeconds?: number | null;
    tenantID?: string | null;
    title?: string | null;
    updatedAt?: string | null;
    userID: string;
    state?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    uploadSource?: string | null;
  } | null;
};

export type ListUserAudioLibrarysQueryVariables = {
  filter?: ModelUserAudioLibraryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListUserAudioLibrarysQuery = {
  listUserAudioLibrarys?: {
    __typename: 'ModelUserAudioLibraryConnection';
    items: Array<{
      __typename: 'UserAudioLibrary';
      id: string;
      audioUrl?: string | null;
      createdAt?: string | null;
      durationSeconds?: number | null;
      tenantID?: string | null;
      title?: string | null;
      updatedAt?: string | null;
      userID: string;
      state?: string | null;
      errorMessage?: string | null;
      errorMessageDisplayToUser?: string | null;
      originalFileExtension?: string | null;
      originalFileMimeType?: string | null;
      uploadSource?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type UserAudioLibraryByUserIdQueryVariables = {
  userID?: string | null;
  sortDirection?: ModelSortDirection | null;
  filter?: ModelUserAudioLibraryFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type UserAudioLibraryByUserIdQuery = {
  UserAudioLibraryByUserId?: {
    __typename: 'ModelUserAudioLibraryConnection';
    items: Array<{
      __typename: 'UserAudioLibrary';
      id: string;
      audioUrl?: string | null;
      createdAt?: string | null;
      durationSeconds?: number | null;
      tenantID?: string | null;
      title?: string | null;
      updatedAt?: string | null;
      userID: string;
      state?: string | null;
      errorMessage?: string | null;
      errorMessageDisplayToUser?: string | null;
      originalFileExtension?: string | null;
      originalFileMimeType?: string | null;
      uploadSource?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type ListUserGiidePermissionssQueryVariables = {
  email?: string | null;
  giideID?: ModelStringKeyConditionInput | null;
  filter?: ModelUserGiidePermissionsFilterInput | null;
  limit?: number | null;
  nextToken?: string | null;
  sortDirection?: ModelSortDirection | null;
};

export type ListUserGiidePermissionssQuery = {
  listUserGiidePermissionss?: {
    __typename: 'ModelUserGiidePermissionsConnection';
    items: Array<{
      __typename: 'UserGiidePermissions';
      email: string;
      giideID: string;
      userID?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      tenantID?: string | null;
    } | null>;
    nextToken?: string | null;
  } | null;
};

export type OnTranscriptionFinishedSubscriptionVariables = {
  tenantID?: string | null;
};

export type OnTranscriptionFinishedSubscription = {
  onTranscriptionFinished?: {
    __typename: 'Recording';
    id: string;
    deleted?: boolean | null;
    length: number;
    step: {
      __typename: 'Step';
      id: string;
      title: string;
      order: number;
      script?: string | null;
      giide: {
        __typename: 'Giide';
        id: string;
        title: string;
        description?: string | null;
        steps?: {
          __typename: 'ModelStepConnection';
          nextToken?: string | null;
        } | null;
        tenantID?: string | null;
        speaker?: {
          __typename: 'Speaker';
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          bio?: string | null;
          title?: string | null;
          profile?: string | null;
          headshotPath?: string | null;
        } | null;
        publishState?: PublishState | null;
        exportVideoState?: string | null;
        unauthenticatedAccessAllowed?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        publishedAt?: string | null;
        publishedWithTranscript?: boolean | null;
        previewedAt?: string | null;
        cardDetails?: {
          __typename: 'CardDetails';
          cardColor?: string | null;
          cardShade?: string | null;
          thumbnailImg?: string | null;
          thumbnailCustomName?: string | null;
          thumbnailCustomPath?: string | null;
          thumbnailImageService?: ImageService | null;
          useCustomThumbnail?: boolean | null;
          colorLeft?: string | null;
          colorRight?: string | null;
          thumbnailLarge?: string | null;
          thumbnailSmall?: string | null;
        } | null;
        preview?: boolean | null;
        isInGiideStudioLibrary?: boolean | null;
        giideLibraryId?: string | null;
        useOwnDescription?: boolean | null;
        useOwnAuthorBio?: boolean | null;
        useGiideTones?: boolean | null;
        script?: string | null;
        hasChapters?: boolean | null;
        noindex?: boolean | null;
        embedCodeState?: string | null;
        embedCodeAllowedDomains?: Array<string | null> | null;
        passwordEnabled?: boolean | null;
      };
      tenantID?: string | null;
      open?: boolean | null;
      ownRecordingUploaded?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      recording?: {
        __typename: 'Recording';
        id: string;
        deleted?: boolean | null;
        length: number;
        step: {
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        };
        feedCards?: {
          __typename: 'ModelFeedCardConnection';
          nextToken?: string | null;
        } | null;
        transcriptResults?: {
          __typename: 'TranscriptResults';
          transcript?: string | null;
        } | null;
        tenantID?: string | null;
        filePath?: string | null;
        transcriptPath?: string | null;
        transcriptError?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        giideId?: string | null;
        libraryRecordId?: string | null;
      } | null;
    };
    feedCards?: {
      __typename: 'ModelFeedCardConnection';
      items: Array<{
        __typename: 'FeedCard';
        nonLibraryGiideID?: string | null;
        id: string;
        source?: string | null;
        time: number;
        title?: string | null;
        type: CardType;
        url?: string | null;
        context?: string | null;
        affiliation?: string | null;
        text?: string | null;
        caption?: string | null;
        question?: string | null;
        feedCardIdForAnalytics?: string | null;
        questionHasCorrectAnswer?: boolean | null;
        customHeader?: string | null;
        questionType?: QuestionType | null;
        answerDetails?: {
          __typename: 'AnswerDetails';
          userAnswer?: string | null;
          userAnswerIsCorrect?: boolean | null;
          correctAnswerIndex?: number | null;
        } | null;
        resourceType?: ResourceType | null;
        iconUrl?: string | null;
        imageUrl?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        bold?: string | null;
        term?: string | null;
        tenantID?: string | null;
        numbered?: boolean | null;
        listItems?: Array<string | null> | null;
        author?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        expertise?: string | null;
        unlinked?: boolean | null;
        customImage?: string | null;
        customImageName?: string | null;
        giideId?: string | null;
        feedCardRecordingId?: string | null;
        imageDetails?: {
          __typename: 'FeedCardImageDetails';
          url?: string | null;
          description?: string | null;
          altDescription?: string | null;
          attributionUserName?: string | null;
          width?: number | null;
          height?: number | null;
          attributionFirstName?: string | null;
          attributionLastName?: string | null;
          attributionFullName?: string | null;
          caption?: string | null;
          imageTypeSelected?: FeedCardImageType | null;
        } | null;
        htmlText?: string | null;
        imageService?: ImageService | null;
        recording: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        };
      } | null>;
      nextToken?: string | null;
    } | null;
    transcriptResults?: {
      __typename: 'TranscriptResults';
      items: Array<{
        __typename: 'TranscriptItem';
        alternatives: Array<{
          __typename: 'TranscriptAlternatives';
          confidence: string;
          content: string;
        }>;
        start_time?: string | null;
        end_time?: string | null;
        type: TranscriptItemType;
      }>;
      transcript?: string | null;
    } | null;
    tenantID?: string | null;
    filePath?: string | null;
    transcriptPath?: string | null;
    transcriptError?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    giideId?: string | null;
    libraryRecordId?: string | null;
  } | null;
};

export type OnOneGiideUpdateSubscriptionVariables = {
  id?: string | null;
};

export type OnOneGiideUpdateSubscription = {
  onOneGiideUpdate?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type OnUpdateGiideSubscriptionVariables = {
  tenantID?: string | null;
};

export type OnUpdateGiideSubscription = {
  onUpdateGiide?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type OnPreviewTriggerSubscriptionVariables = {
  owner?: string | null;
};

export type OnPreviewTriggerSubscription = {
  onPreviewTrigger?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type OnCreateGiideAdminSubscriptionVariables = {
  tenantID?: string | null;
};

export type OnCreateGiideAdminSubscription = {
  onCreateGiideAdmin?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type OnCreateGiideAuthorSubscriptionVariables = {
  owner?: string | null;
};

export type OnCreateGiideAuthorSubscription = {
  onCreateGiideAuthor?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type OnDeleteGiideAdminSubscriptionVariables = {
  tenantID?: string | null;
};

export type OnDeleteGiideAdminSubscription = {
  onDeleteGiideAdmin?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type OnDeleteGiideAuthorSubscriptionVariables = {
  owner?: string | null;
};

export type OnDeleteGiideAuthorSubscription = {
  onDeleteGiideAuthor?: {
    __typename: 'Giide';
    id: string;
    title: string;
    description?: string | null;
    steps?: {
      __typename: 'ModelStepConnection';
      items: Array<{
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      } | null>;
      nextToken?: string | null;
    } | null;
    tenantID?: string | null;
    speaker?: {
      __typename: 'Speaker';
      firstName?: string | null;
      lastName?: string | null;
      fullName?: string | null;
      bio?: string | null;
      title?: string | null;
      socialUrls?: {
        __typename: 'SocialUrls';
        facebook?: string | null;
        twitter?: string | null;
        linkedin?: string | null;
        website?: string | null;
      } | null;
      profile?: string | null;
      headshotPath?: string | null;
    } | null;
    publishState?: PublishState | null;
    exportVideoState?: string | null;
    unauthenticatedAccessAllowed?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    publishedWithTranscript?: boolean | null;
    previewedAt?: string | null;
    cardDetails?: {
      __typename: 'CardDetails';
      cardColor?: string | null;
      cardShade?: string | null;
      thumbnailImg?: string | null;
      thumbnailCustomName?: string | null;
      thumbnailCustomPath?: string | null;
      thumbnailImageService?: ImageService | null;
      useCustomThumbnail?: boolean | null;
      colorLeft?: string | null;
      colorRight?: string | null;
      thumbnailLarge?: string | null;
      thumbnailSmall?: string | null;
    } | null;
    preview?: boolean | null;
    isInGiideStudioLibrary?: boolean | null;
    giideLibraryId?: string | null;
    useOwnDescription?: boolean | null;
    useOwnAuthorBio?: boolean | null;
    useGiideTones?: boolean | null;
    script?: string | null;
    hasChapters?: boolean | null;
    noindex?: boolean | null;
    embedCodeState?: string | null;
    embedCodeAllowedDomains?: Array<string | null> | null;
    passwordEnabled?: boolean | null;
  } | null;
};

export type OnCreateAudioLibraryItemSubscriptionVariables = {
  userID?: string | null;
};

export type OnCreateAudioLibraryItemSubscription = {
  onCreateAudioLibraryItem?: {
    __typename: 'UserAudioLibrary';
    id: string;
    audioUrl?: string | null;
    createdAt?: string | null;
    durationSeconds?: number | null;
    tenantID?: string | null;
    title?: string | null;
    updatedAt?: string | null;
    userID: string;
    state?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    uploadSource?: string | null;
  } | null;
};

export type OnUpdateAudioLibraryItemSubscriptionVariables = {
  userID?: string | null;
};

export type OnUpdateAudioLibraryItemSubscription = {
  onUpdateAudioLibraryItem?: {
    __typename: 'UserAudioLibrary';
    id: string;
    audioUrl?: string | null;
    createdAt?: string | null;
    durationSeconds?: number | null;
    tenantID?: string | null;
    title?: string | null;
    updatedAt?: string | null;
    userID: string;
    state?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    uploadSource?: string | null;
  } | null;
};

export type OnDeleteAudioLibraryItemSubscriptionVariables = {
  userID?: string | null;
};

export type OnDeleteAudioLibraryItemSubscription = {
  onDeleteAudioLibraryItem?: {
    __typename: 'UserAudioLibrary';
    id: string;
    audioUrl?: string | null;
    createdAt?: string | null;
    durationSeconds?: number | null;
    tenantID?: string | null;
    title?: string | null;
    updatedAt?: string | null;
    userID: string;
    state?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    uploadSource?: string | null;
  } | null;
};

export type OnUpdateUserImageRecordSubscriptionVariables = {
  userID?: string | null;
};

export type OnUpdateUserImageRecordSubscription = {
  onUpdateUserImageRecord?: {
    __typename: 'UserImage';
    id: string;
    userID: string;
    feedCardId?: string | null;
    imageUrl?: string | null;
    type?: ImageUploadType | null;
    imageService?: ImageService | null;
    createdAt?: string | null;
    fileName?: string | null;
    state?: string | null;
    originalFileExtension?: string | null;
    originalFileMimeType?: string | null;
    errorMessage?: string | null;
    errorMessageDisplayToUser?: string | null;
  } | null;
};

export type OnUpdateUserPlanTimeStampSubscriptionVariables = {
  userID: string;
  tenantID: string;
};

export type OnUpdateUserPlanTimeStampSubscription = {
  onUpdateUserPlanTimeStamp?: {
    __typename: 'GetPlanOutput';
    id?: string | null;
    versionID?: string | null;
    updatedAt?: string | null;
    createdAt?: string | null;
    price?: number | null;
    name?: string | null;
    features?: {
      __typename: 'PlanFeatures';
      giideMaxLengthAudio?: {
        __typename: 'PlanMaxLengthAudio';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        giideLengthInSeconds?: number | null;
        updatedAt?: string | null;
      } | null;
      giideMaxFileSizeAudio?: {
        __typename: 'PlanMaxFileSizeAudio';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        giideMaxFileSizeMBAudio?: number | null;
        updatedAt?: string | null;
      } | null;
      giideMaxNumberOfGiides?: {
        __typename: 'PlanMaxNumberOfGiides';
        createdAt?: string | null;
        hasLimit?: boolean | null;
        isActive?: boolean | null;
        limitAmount?: number | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
      chapters?: {
        __typename: 'PlanChapters';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        hasLimit?: boolean | null;
        maxNumberOfChapters?: number | null;
        allowChaptersWithFutureGiides?: boolean | null;
        allowChaptersWithExistingGiides?: boolean | null;
        updatedAt?: string | null;
      } | null;
      recording?: {
        __typename: 'PlanRecording';
        name?: string | null;
        createdAt?: string | null;
        hasBrowserRecording?: boolean | null;
        updatedAt?: string | null;
      } | null;
      embedCode?: {
        __typename: 'PlanEmbedCode';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        updatedAt?: string | null;
        allowEmbedCode?: boolean | null;
      } | null;
      pollQuizFeature?: {
        __typename: 'PlanPollQuizFeature';
        name?: string | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        updatedAt?: string | null;
        allowFeature?: boolean | null;
      } | null;
      giidePasswordProtection?: {
        __typename: 'PlanGiidePasswordProtection';
        allowGiidePasswordProtection?: boolean | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
      giideDuplicate?: {
        __typename: 'PlanGiideDuplicate';
        allowGiideDuplicate?: boolean | null;
        createdAt?: string | null;
        isActive?: boolean | null;
        name?: string | null;
        updatedAt?: string | null;
      } | null;
    } | null;
    userID?: string | null;
    tenantID?: string | null;
    giidesCreatedListFreePlan?: Array<{
      __typename: 'GiidesCreated';
      giideID?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    giidesCreatedListProPlan?: Array<{
      __typename: 'GiidesCreated';
      giideID?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null> | null;
    subscriptionIDs?: Array<number | null> | null;
    accountStatus?: string | null;
    freeTrialEndDate?: string | null;
    totalGiidesCreated?: number | null;
    upgradePlans?: Array<number | null> | null;
    downgradePlans?: Array<number | null> | null;
    planChangeError?: string | null;
    paddlePlanID?: number | null;
  } | null;
};

export type OnUpdateStepSubscriptionVariables = {
  owner?: string | null;
};

export type OnUpdateStepSubscription = {
  onUpdateStep?: {
    __typename: 'Step';
    id: string;
    title: string;
    order: number;
    script?: string | null;
    giide: {
      __typename: 'Giide';
      id: string;
      title: string;
      description?: string | null;
      steps?: {
        __typename: 'ModelStepConnection';
        items: Array<{
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      tenantID?: string | null;
      speaker?: {
        __typename: 'Speaker';
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        bio?: string | null;
        title?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        profile?: string | null;
        headshotPath?: string | null;
      } | null;
      publishState?: PublishState | null;
      exportVideoState?: string | null;
      unauthenticatedAccessAllowed?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publishedAt?: string | null;
      publishedWithTranscript?: boolean | null;
      previewedAt?: string | null;
      cardDetails?: {
        __typename: 'CardDetails';
        cardColor?: string | null;
        cardShade?: string | null;
        thumbnailImg?: string | null;
        thumbnailCustomName?: string | null;
        thumbnailCustomPath?: string | null;
        thumbnailImageService?: ImageService | null;
        useCustomThumbnail?: boolean | null;
        colorLeft?: string | null;
        colorRight?: string | null;
        thumbnailLarge?: string | null;
        thumbnailSmall?: string | null;
      } | null;
      preview?: boolean | null;
      isInGiideStudioLibrary?: boolean | null;
      giideLibraryId?: string | null;
      useOwnDescription?: boolean | null;
      useOwnAuthorBio?: boolean | null;
      useGiideTones?: boolean | null;
      script?: string | null;
      hasChapters?: boolean | null;
      noindex?: boolean | null;
      embedCodeState?: string | null;
      embedCodeAllowedDomains?: Array<string | null> | null;
      passwordEnabled?: boolean | null;
    };
    tenantID?: string | null;
    open?: boolean | null;
    ownRecordingUploaded?: boolean | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    recording?: {
      __typename: 'Recording';
      id: string;
      deleted?: boolean | null;
      length: number;
      step: {
        __typename: 'Step';
        id: string;
        title: string;
        order: number;
        script?: string | null;
        giide: {
          __typename: 'Giide';
          id: string;
          title: string;
          description?: string | null;
          tenantID?: string | null;
          publishState?: PublishState | null;
          exportVideoState?: string | null;
          unauthenticatedAccessAllowed?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          publishedAt?: string | null;
          publishedWithTranscript?: boolean | null;
          previewedAt?: string | null;
          preview?: boolean | null;
          isInGiideStudioLibrary?: boolean | null;
          giideLibraryId?: string | null;
          useOwnDescription?: boolean | null;
          useOwnAuthorBio?: boolean | null;
          useGiideTones?: boolean | null;
          script?: string | null;
          hasChapters?: boolean | null;
          noindex?: boolean | null;
          embedCodeState?: string | null;
          embedCodeAllowedDomains?: Array<string | null> | null;
          passwordEnabled?: boolean | null;
        };
        tenantID?: string | null;
        open?: boolean | null;
        ownRecordingUploaded?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        recording?: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        } | null;
      };
      feedCards?: {
        __typename: 'ModelFeedCardConnection';
        items: Array<{
          __typename: 'FeedCard';
          nonLibraryGiideID?: string | null;
          id: string;
          source?: string | null;
          time: number;
          title?: string | null;
          type: CardType;
          url?: string | null;
          context?: string | null;
          affiliation?: string | null;
          text?: string | null;
          caption?: string | null;
          question?: string | null;
          feedCardIdForAnalytics?: string | null;
          questionHasCorrectAnswer?: boolean | null;
          customHeader?: string | null;
          questionType?: QuestionType | null;
          resourceType?: ResourceType | null;
          iconUrl?: string | null;
          imageUrl?: string | null;
          bold?: string | null;
          term?: string | null;
          tenantID?: string | null;
          numbered?: boolean | null;
          listItems?: Array<string | null> | null;
          author?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          expertise?: string | null;
          unlinked?: boolean | null;
          customImage?: string | null;
          customImageName?: string | null;
          giideId?: string | null;
          feedCardRecordingId?: string | null;
          htmlText?: string | null;
          imageService?: ImageService | null;
        } | null>;
        nextToken?: string | null;
      } | null;
      transcriptResults?: {
        __typename: 'TranscriptResults';
        items: Array<{
          __typename: 'TranscriptItem';
          start_time?: string | null;
          end_time?: string | null;
          type: TranscriptItemType;
        }>;
        transcript?: string | null;
      } | null;
      tenantID?: string | null;
      filePath?: string | null;
      transcriptPath?: string | null;
      transcriptError?: string | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      giideId?: string | null;
      libraryRecordId?: string | null;
    } | null;
  } | null;
};

export type OnCreateRecordingSubscriptionVariables = {
  owner?: string | null;
};

export type OnCreateRecordingSubscription = {
  onCreateRecording?: {
    __typename: 'Recording';
    id: string;
    deleted?: boolean | null;
    length: number;
    step: {
      __typename: 'Step';
      id: string;
      title: string;
      order: number;
      script?: string | null;
      giide: {
        __typename: 'Giide';
        id: string;
        title: string;
        description?: string | null;
        steps?: {
          __typename: 'ModelStepConnection';
          nextToken?: string | null;
        } | null;
        tenantID?: string | null;
        speaker?: {
          __typename: 'Speaker';
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          bio?: string | null;
          title?: string | null;
          profile?: string | null;
          headshotPath?: string | null;
        } | null;
        publishState?: PublishState | null;
        exportVideoState?: string | null;
        unauthenticatedAccessAllowed?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        publishedAt?: string | null;
        publishedWithTranscript?: boolean | null;
        previewedAt?: string | null;
        cardDetails?: {
          __typename: 'CardDetails';
          cardColor?: string | null;
          cardShade?: string | null;
          thumbnailImg?: string | null;
          thumbnailCustomName?: string | null;
          thumbnailCustomPath?: string | null;
          thumbnailImageService?: ImageService | null;
          useCustomThumbnail?: boolean | null;
          colorLeft?: string | null;
          colorRight?: string | null;
          thumbnailLarge?: string | null;
          thumbnailSmall?: string | null;
        } | null;
        preview?: boolean | null;
        isInGiideStudioLibrary?: boolean | null;
        giideLibraryId?: string | null;
        useOwnDescription?: boolean | null;
        useOwnAuthorBio?: boolean | null;
        useGiideTones?: boolean | null;
        script?: string | null;
        hasChapters?: boolean | null;
        noindex?: boolean | null;
        embedCodeState?: string | null;
        embedCodeAllowedDomains?: Array<string | null> | null;
        passwordEnabled?: boolean | null;
      };
      tenantID?: string | null;
      open?: boolean | null;
      ownRecordingUploaded?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      recording?: {
        __typename: 'Recording';
        id: string;
        deleted?: boolean | null;
        length: number;
        step: {
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        };
        feedCards?: {
          __typename: 'ModelFeedCardConnection';
          nextToken?: string | null;
        } | null;
        transcriptResults?: {
          __typename: 'TranscriptResults';
          transcript?: string | null;
        } | null;
        tenantID?: string | null;
        filePath?: string | null;
        transcriptPath?: string | null;
        transcriptError?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        giideId?: string | null;
        libraryRecordId?: string | null;
      } | null;
    };
    feedCards?: {
      __typename: 'ModelFeedCardConnection';
      items: Array<{
        __typename: 'FeedCard';
        nonLibraryGiideID?: string | null;
        id: string;
        source?: string | null;
        time: number;
        title?: string | null;
        type: CardType;
        url?: string | null;
        context?: string | null;
        affiliation?: string | null;
        text?: string | null;
        caption?: string | null;
        question?: string | null;
        feedCardIdForAnalytics?: string | null;
        questionHasCorrectAnswer?: boolean | null;
        customHeader?: string | null;
        questionType?: QuestionType | null;
        answerDetails?: {
          __typename: 'AnswerDetails';
          userAnswer?: string | null;
          userAnswerIsCorrect?: boolean | null;
          correctAnswerIndex?: number | null;
        } | null;
        resourceType?: ResourceType | null;
        iconUrl?: string | null;
        imageUrl?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        bold?: string | null;
        term?: string | null;
        tenantID?: string | null;
        numbered?: boolean | null;
        listItems?: Array<string | null> | null;
        author?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        expertise?: string | null;
        unlinked?: boolean | null;
        customImage?: string | null;
        customImageName?: string | null;
        giideId?: string | null;
        feedCardRecordingId?: string | null;
        imageDetails?: {
          __typename: 'FeedCardImageDetails';
          url?: string | null;
          description?: string | null;
          altDescription?: string | null;
          attributionUserName?: string | null;
          width?: number | null;
          height?: number | null;
          attributionFirstName?: string | null;
          attributionLastName?: string | null;
          attributionFullName?: string | null;
          caption?: string | null;
          imageTypeSelected?: FeedCardImageType | null;
        } | null;
        htmlText?: string | null;
        imageService?: ImageService | null;
        recording: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        };
      } | null>;
      nextToken?: string | null;
    } | null;
    transcriptResults?: {
      __typename: 'TranscriptResults';
      items: Array<{
        __typename: 'TranscriptItem';
        alternatives: Array<{
          __typename: 'TranscriptAlternatives';
          confidence: string;
          content: string;
        }>;
        start_time?: string | null;
        end_time?: string | null;
        type: TranscriptItemType;
      }>;
      transcript?: string | null;
    } | null;
    tenantID?: string | null;
    filePath?: string | null;
    transcriptPath?: string | null;
    transcriptError?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    giideId?: string | null;
    libraryRecordId?: string | null;
  } | null;
};

export type OnExportVideoUpdateSubscriptionVariables = {
  id?: string | null;
};

export type OnExportVideoUpdateSubscription = {
  onExportVideoUpdate?: {
    __typename: 'ExportVideoOutput';
    id: string;
    error?: boolean | null;
    status?: string | null;
    progress?: number | null;
  } | null;
};

export type OnGetAiChatResponseSubscriptionVariables = {
  giideId: string;
};

export type OnGetAiChatResponseSubscription = {
  onGetAiChatResponse?: {
    __typename: 'AiGetChatResponseOutput';
    giideId: string;
    script: string;
  } | null;
};

export type OnUpdateRecordingSubscriptionVariables = {
  owner?: string | null;
};

export type OnUpdateRecordingSubscription = {
  onUpdateRecording?: {
    __typename: 'Recording';
    id: string;
    deleted?: boolean | null;
    length: number;
    step: {
      __typename: 'Step';
      id: string;
      title: string;
      order: number;
      script?: string | null;
      giide: {
        __typename: 'Giide';
        id: string;
        title: string;
        description?: string | null;
        steps?: {
          __typename: 'ModelStepConnection';
          nextToken?: string | null;
        } | null;
        tenantID?: string | null;
        speaker?: {
          __typename: 'Speaker';
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          bio?: string | null;
          title?: string | null;
          profile?: string | null;
          headshotPath?: string | null;
        } | null;
        publishState?: PublishState | null;
        exportVideoState?: string | null;
        unauthenticatedAccessAllowed?: boolean | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        publishedAt?: string | null;
        publishedWithTranscript?: boolean | null;
        previewedAt?: string | null;
        cardDetails?: {
          __typename: 'CardDetails';
          cardColor?: string | null;
          cardShade?: string | null;
          thumbnailImg?: string | null;
          thumbnailCustomName?: string | null;
          thumbnailCustomPath?: string | null;
          thumbnailImageService?: ImageService | null;
          useCustomThumbnail?: boolean | null;
          colorLeft?: string | null;
          colorRight?: string | null;
          thumbnailLarge?: string | null;
          thumbnailSmall?: string | null;
        } | null;
        preview?: boolean | null;
        isInGiideStudioLibrary?: boolean | null;
        giideLibraryId?: string | null;
        useOwnDescription?: boolean | null;
        useOwnAuthorBio?: boolean | null;
        useGiideTones?: boolean | null;
        script?: string | null;
        hasChapters?: boolean | null;
        noindex?: boolean | null;
        embedCodeState?: string | null;
        embedCodeAllowedDomains?: Array<string | null> | null;
        passwordEnabled?: boolean | null;
      };
      tenantID?: string | null;
      open?: boolean | null;
      ownRecordingUploaded?: boolean | null;
      owner?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      recording?: {
        __typename: 'Recording';
        id: string;
        deleted?: boolean | null;
        length: number;
        step: {
          __typename: 'Step';
          id: string;
          title: string;
          order: number;
          script?: string | null;
          tenantID?: string | null;
          open?: boolean | null;
          ownRecordingUploaded?: boolean | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        };
        feedCards?: {
          __typename: 'ModelFeedCardConnection';
          nextToken?: string | null;
        } | null;
        transcriptResults?: {
          __typename: 'TranscriptResults';
          transcript?: string | null;
        } | null;
        tenantID?: string | null;
        filePath?: string | null;
        transcriptPath?: string | null;
        transcriptError?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        giideId?: string | null;
        libraryRecordId?: string | null;
      } | null;
    };
    feedCards?: {
      __typename: 'ModelFeedCardConnection';
      items: Array<{
        __typename: 'FeedCard';
        nonLibraryGiideID?: string | null;
        id: string;
        source?: string | null;
        time: number;
        title?: string | null;
        type: CardType;
        url?: string | null;
        context?: string | null;
        affiliation?: string | null;
        text?: string | null;
        caption?: string | null;
        question?: string | null;
        feedCardIdForAnalytics?: string | null;
        questionHasCorrectAnswer?: boolean | null;
        customHeader?: string | null;
        questionType?: QuestionType | null;
        answerDetails?: {
          __typename: 'AnswerDetails';
          userAnswer?: string | null;
          userAnswerIsCorrect?: boolean | null;
          correctAnswerIndex?: number | null;
        } | null;
        resourceType?: ResourceType | null;
        iconUrl?: string | null;
        imageUrl?: string | null;
        socialUrls?: {
          __typename: 'SocialUrls';
          facebook?: string | null;
          twitter?: string | null;
          linkedin?: string | null;
          website?: string | null;
        } | null;
        bold?: string | null;
        term?: string | null;
        tenantID?: string | null;
        numbered?: boolean | null;
        listItems?: Array<string | null> | null;
        author?: string | null;
        owner?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        expertise?: string | null;
        unlinked?: boolean | null;
        customImage?: string | null;
        customImageName?: string | null;
        giideId?: string | null;
        feedCardRecordingId?: string | null;
        imageDetails?: {
          __typename: 'FeedCardImageDetails';
          url?: string | null;
          description?: string | null;
          altDescription?: string | null;
          attributionUserName?: string | null;
          width?: number | null;
          height?: number | null;
          attributionFirstName?: string | null;
          attributionLastName?: string | null;
          attributionFullName?: string | null;
          caption?: string | null;
          imageTypeSelected?: FeedCardImageType | null;
        } | null;
        htmlText?: string | null;
        imageService?: ImageService | null;
        recording: {
          __typename: 'Recording';
          id: string;
          deleted?: boolean | null;
          length: number;
          tenantID?: string | null;
          filePath?: string | null;
          transcriptPath?: string | null;
          transcriptError?: string | null;
          owner?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
          giideId?: string | null;
          libraryRecordId?: string | null;
        };
      } | null>;
      nextToken?: string | null;
    } | null;
    transcriptResults?: {
      __typename: 'TranscriptResults';
      items: Array<{
        __typename: 'TranscriptItem';
        alternatives: Array<{
          __typename: 'TranscriptAlternatives';
          confidence: string;
          content: string;
        }>;
        start_time?: string | null;
        end_time?: string | null;
        type: TranscriptItemType;
      }>;
      transcript?: string | null;
    } | null;
    tenantID?: string | null;
    filePath?: string | null;
    transcriptPath?: string | null;
    transcriptError?: string | null;
    owner?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    giideId?: string | null;
    libraryRecordId?: string | null;
  } | null;
};
